(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection"]) return;
  try {
    
  (() => {
    const setup = () => {
      const root = document.querySelector('[data-luvora-collection-infinite-root]');
      if (!root || root.dataset.luvoraCollectionInfiniteBound === '1') return;

      const grid = root.querySelector('[data-luvora-collection-product-grid]');
      const sentinel = root.querySelector('[data-luvora-collection-sentinel]');
      const totalPages = parseInt(root.dataset.totalPages, 10);
      const sectionId = root.dataset.sectionId;

      if (!grid || !sentinel) return;
      if (!sectionId) return;
      if (!Number.isFinite(totalPages) || totalPages <= 1) return;

      root.dataset.luvoraCollectionInfiniteBound = '1';

      // Infinite scroll is taking over, so the crawlable fallback links are redundant.
      const paginationEl = root.querySelector('[data-luvora-collection-pagination]');
      if (paginationEl) paginationEl.remove();

      const loadingEl = sentinel.querySelector('[data-luvora-collection-infinite-loading]');
      const errorEl = sentinel.querySelector('[data-luvora-collection-infinite-error]');

      let currentPage = parseInt(root.dataset.currentPage, 10);
      let loading = false;
      let observerInstance = null;

      const failMessage = () => root.dataset.infiniteErrorText || '';

      const setBusy = (busy) => {
        sentinel.setAttribute('aria-busy', busy ? 'true' : 'false');
        if (loadingEl) loadingEl.classList.toggle('hidden', !busy);
        if (errorEl) {
          errorEl.classList.add('hidden');
          errorEl.textContent = '';
        }
      };

      const showError = (message) => {
        setBusy(false);
        loading = false;
        if (errorEl) {
          errorEl.textContent = message;
          errorEl.classList.remove('hidden');
        }
      };

      const finish = () => {
        loading = false;
        setBusy(false);
        if (observerInstance) {
          observerInstance.disconnect();
        }
        sentinel.remove();
        root.dataset.luvoraCollectionInfiniteBound = 'done';
      };

      const loadNext = async () => {
        if (loading) return;
        if (!Number.isFinite(currentPage) || currentPage >= totalPages) {
          finish();
          return;
        }

        const nextPage = currentPage + 1;
        loading = true;
        setBusy(true);

        let requestUrl;
        try {
          requestUrl = new URL(window.location.href);
        } catch {
          showError(failMessage());
          return;
        }

        requestUrl.searchParams.delete('sections');
        requestUrl.searchParams.set('section_id', sectionId);
        requestUrl.searchParams.set('page', String(nextPage));

        let response;
        try {
          response = await fetch(requestUrl.toString(), {
            credentials: 'same-origin',
            redirect: 'follow',
          });
        } catch {
          showError(failMessage());
          return;
        }

        if (!response.ok) {
          showError(failMessage());
          return;
        }

        let html;
        try {
          html = await response.text();
        } catch {
          showError(failMessage());
          return;
        }

        const trimmed = html.trim();
        if (trimmed.startsWith('{')) {
          let parsedHtml = null;
          try {
            const payload = JSON.parse(trimmed);
            const values = Object.values(payload);
            for (let i = 0; i < values.length; i += 1) {
              const v = values[i];
              if (typeof v === 'string' && v.includes('data-luvora-collection-product-grid')) {
                parsedHtml = v;
                break;
              }
            }
            if (!parsedHtml) {
              for (let j = 0; j < values.length; j += 1) {
                const w = values[j];
                if (typeof w === 'string' && w.includes('shopify-section')) {
                  parsedHtml = w;
                  break;
                }
              }
            }
          } catch {
            parsedHtml = null;
          }
          if (!parsedHtml) {
            showError(failMessage());
            return;
          }
          html = parsedHtml;
        }

        const doc = new DOMParser().parseFromString(html, 'text/html');
        const nextGrid = doc.querySelector('[data-luvora-collection-product-grid]');
        if (!nextGrid) {
          showError(failMessage());
          return;
        }

        const toAppend = Array.from(nextGrid.children);
        if (toAppend.length === 0) {
          finish();
          return;
        }

        toAppend.forEach((node) => {
          grid.appendChild(node);
        });

        currentPage = nextPage;
        root.dataset.currentPage = String(currentPage);

        document.dispatchEvent(
          new CustomEvent('luvora:product-cards-bind', {
            detail: { root: grid },
          }),
        );

        loading = false;
        setBusy(false);

        if (currentPage >= totalPages) {
          finish();
        }
      };

      observerInstance = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            loadNext();
          });
        },
        { root: null, rootMargin: '0px 0px 480px 0px', threshold: 0 },
      );

      observerInstance.observe(sentinel);
    };

    /*
     * Sorting without a page load. The toolbar fires a cancelable
     * collection:sort; we swap the whole collection root for the freshly
     * rendered one and re-run setup, because infinite scroll keeps its page
     * counter and observer in a closure and would otherwise carry on
     * appending pages of the previous sort order.
     */
    let sorting = false;

    const applySort = (value) => {
      const root = document.querySelector('[data-luvora-collection-infinite-root]');
      if (!root || sorting) return;
      const sectionId = root.dataset.sectionId;
      if (!sectionId) return;
      sorting = true;

      const target = new URL(window.location.href);
      target.searchParams.set('sort_by', value);
      /* A page number from the old order means nothing in the new one. */
      target.searchParams.delete('page');

      const requestUrl = new URL(target.href);
      requestUrl.searchParams.set('section_id', sectionId);

      root.setAttribute('aria-busy', 'true');

      fetch(requestUrl.toString(), { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
        .then((response) => {
          if (!response.ok) throw new Error(String(response.status));
          return response.text();
        })
        .then((html) => {
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const next = doc.querySelector('[data-luvora-collection-infinite-root]');
          if (!next) throw new Error('missing root');
          root.replaceWith(next);
          /* The product cards are new nodes too: without this the swatch hover is dead after a sort. */
          document.dispatchEvent(new CustomEvent('luvora:product-cards-bind', { detail: { root: next } }));
          window.history.pushState({ sort: value }, '', target.href);
          setup();
          sorting = false;
        })
        .catch(() => {
          /* Better a full load than leaving the old order under a new label. */
          sorting = false;
          window.location.href = target.href;
        });
    };

    document.addEventListener('collection:sort', (event) => {
      event.preventDefault();
      applySort(event.detail.value);
    });

    /* The grid was replaced, not navigated, so restore by reloading. */
    window.addEventListener('popstate', () => {
      window.location.reload();
    });

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', setup);
    } else {
      setup();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["diamanter"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const SECTION_SELECTOR = 'section.diamanter-faq';
    const DETAILS_SELECTOR = 'details.diamanter-faq__item';
    const CLIP_CLASS = 'diamanter-faq__answer-clip';
    const ANSWER_CLASS = 'diamanter-faq__answer';

    function prefersReducedMotion() {
      return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    }

    function bindDetails(details) {
      if (details.dataset.faqMotionBound === '1') return;
      if (prefersReducedMotion()) return;

      const summary = details.querySelector(':scope > summary');
      const clip = details.querySelector(':scope > .'.concat(CLIP_CLASS));
      const answer = clip && clip.querySelector('.'.concat(ANSWER_CLASS));
      if (!summary || !clip || !answer) return;

      details.dataset.faqMotionBound = '1';

      summary.addEventListener('click', function (e) {
        e.preventDefault();

        if (details.open) {
          clip.style.maxHeight = ''.concat(clip.scrollHeight, 'px');
          clip.getBoundingClientRect();
          clip.style.maxHeight = '0px';

          function onEnd(ev) {
            if (ev.target !== clip || ev.propertyName !== 'max-height') return;
            clip.removeEventListener('transitionend', onEnd);
            details.open = false;
            clip.style.maxHeight = '';
          }

          clip.addEventListener('transitionend', onEnd);
        } else {
          details.open = true;
          clip.style.maxHeight = '0px';
          var targetH = answer.scrollHeight;
          requestAnimationFrame(function () {
            requestAnimationFrame(function () {
              clip.style.maxHeight = ''.concat(targetH, 'px');
            });
          });

          function onOpenEnd(ev) {
            if (ev.target !== clip || ev.propertyName !== 'max-height') return;
            clip.removeEventListener('transitionend', onOpenEnd);
            if (details.open) clip.style.maxHeight = 'none';
          }

          clip.addEventListener('transitionend', onOpenEnd);
        }
      });
    }

    function initFaqMotion(root) {
      var scope = root || document;
      scope.querySelectorAll(SECTION_SELECTOR + ' ' + DETAILS_SELECTOR).forEach(bindDetails);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        initFaqMotion();
      });
    } else {
      initFaqMotion();
    }

    document.addEventListener('shopify:section:load', function (event) {
      if (event.target && event.target.querySelector && event.target.querySelector(SECTION_SELECTOR)) {
        initFaqMotion(event.target);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq-page"]) return;
  try {
    
  (function () {
    const ROOT_SELECTOR = '[data-faq-root]';
    const DETAILS_SELECTOR = 'details.faq-page-faq__item';
    const CLIP_CLASS = 'faq-page-faq__answer-clip';
    const ANSWER_CLASS = 'faq-page-faq__answer';

    function prefersReducedMotion() {
      return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    }

    function closeDetails(details) {
      const clip = details.querySelector(':scope > .'.concat(CLIP_CLASS));
      if (!details.open) return;

      if (!clip || prefersReducedMotion() || details.dataset.faqMotionBound !== '1') {
        details.open = false;
        if (clip) clip.style.maxHeight = '';
        return;
      }

      clip.style.maxHeight = ''.concat(clip.scrollHeight, 'px');
      clip.getBoundingClientRect();
      clip.style.maxHeight = '0px';

      function onEnd(ev) {
        if (ev.target !== clip || ev.propertyName !== 'max-height') return;
        clip.removeEventListener('transitionend', onEnd);
        details.open = false;
        clip.style.maxHeight = '';
      }

      clip.addEventListener('transitionend', onEnd);
    }

    function closeOtherOpenDetails(root, exceptDetails) {
      root.querySelectorAll(DETAILS_SELECTOR).forEach(function (other) {
        if (other === exceptDetails || !other.open) return;
        closeDetails(other);
      });
    }

    function bindAccordion(details) {
      if (details.dataset.faqAccordionBound === '1') return;
      details.dataset.faqAccordionBound = '1';

      details.addEventListener('toggle', function () {
        if (!details.open) return;
        const root = details.closest(ROOT_SELECTOR);
        if (!root) return;
        closeOtherOpenDetails(root, details);
      });
    }

    function bindDetails(details) {
      if (details.dataset.faqMotionBound === '1') return;
      if (prefersReducedMotion()) return;

      const summary = details.querySelector(':scope > summary');
      const clip = details.querySelector(':scope > .'.concat(CLIP_CLASS));
      const answer = clip && clip.querySelector('.'.concat(ANSWER_CLASS));
      if (!summary || !clip || !answer) return;

      details.dataset.faqMotionBound = '1';

      summary.addEventListener('click', function (e) {
        e.preventDefault();

        if (details.open) {
          closeDetails(details);
        } else {
          const root = details.closest(ROOT_SELECTOR);
          if (root) closeOtherOpenDetails(root, details);

          details.open = true;
          clip.style.maxHeight = '0px';
          var targetH = answer.scrollHeight;
          requestAnimationFrame(function () {
            requestAnimationFrame(function () {
              clip.style.maxHeight = ''.concat(targetH, 'px');
            });
          });

          function onOpenEnd(ev) {
            if (ev.target !== clip || ev.propertyName !== 'max-height') return;
            clip.removeEventListener('transitionend', onOpenEnd);
            if (details.open) clip.style.maxHeight = 'none';
          }

          clip.addEventListener('transitionend', onOpenEnd);
        }
      });
    }

    function initFaq(root) {
      const scope = root || document;
      scope.querySelectorAll(ROOT_SELECTOR + ' ' + DETAILS_SELECTOR).forEach(function (details) {
        bindAccordion(details);
        bindDetails(details);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        initFaq();
      });
    } else {
      initFaq();
    }

    document.addEventListener('shopify:section:load', function (event) {
      if (event.target && event.target.querySelector && event.target.querySelector(ROOT_SELECTOR)) {
        initFaq(event.target);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (() => {
    const headerMeasureEl = document.getElementById('luvora-header');
    const syncLayoutHeaderOffset = () => {
      if (!headerMeasureEl) return;
      const h = Math.ceil(headerMeasureEl.getBoundingClientRect().height);
      document.documentElement.style.setProperty('--luvora-layout-header-offset', `${h}px`);
    };
    syncLayoutHeaderOffset();
    window.addEventListener('resize', syncLayoutHeaderOffset, { passive: true });
    if (window.ResizeObserver && headerMeasureEl) {
      const ro = new ResizeObserver(() => syncLayoutHeaderOffset());
      ro.observe(headerMeasureEl);
    }

    const headerTopStrips = document.querySelectorAll('[data-header-top-strip]');
    const searchModal = document.querySelector('[data-search-modal]');
    const openSearchButtons = document.querySelectorAll('[data-open-search-modal]');
    const closeSearchButtons = document.querySelectorAll('[data-close-search-modal]');
    const searchInput = document.getElementById('search-modal-input');

    const stripHideAfter = 40;
    const stripShowBelow = 8;
    let stripScrollRaf = 0;
    let stripScrollInited = false;
    const syncHeaderTopStrip = (useHysteresis) => {
      const y = window.scrollY;
      headerTopStrips.forEach((strip) => {
        const wasHidden = strip.classList.contains('is-hidden');
        let nextHidden = wasHidden;
        if (useHysteresis) {
          if (y > stripHideAfter) {
            nextHidden = true;
          } else if (y < stripShowBelow) {
            nextHidden = false;
          }
        } else {
          nextHidden = y > stripHideAfter;
        }
        if (nextHidden !== wasHidden) {
          strip.classList.toggle('is-hidden', nextHidden);
        }
      });
    };
    const toggleHeaderTopStrip = () => {
      if (stripScrollRaf) return;
      stripScrollRaf = window.requestAnimationFrame(() => {
        stripScrollRaf = 0;
        syncHeaderTopStrip(stripScrollInited);
        stripScrollInited = true;
      });
    };

    /*
      Sale announcement bar countdown (disabled for reuse later):
      const saleAnnouncementBar = document.querySelector('[data-sale-announcement-bar]');
      const initSaleAnnouncementBar = () => {
        if (!saleAnnouncementBar) return;
        const endIso = saleAnnouncementBar.dataset.saleEnd;
        if (!endIso) return;
        const endMs = Date.parse(endIso);
        if (Number.isNaN(endMs)) return;
        const countdownEl = saleAnnouncementBar.querySelector('[data-sale-countdown]');
        const pad = (value) => String(value).padStart(2, '0');
        let saleCountdownTimer = 0;
        const hideSaleBar = () => {
          saleAnnouncementBar.classList.add('hidden');
          if (saleCountdownTimer) {
            window.clearInterval(saleCountdownTimer);
            saleCountdownTimer = 0;
          }
          syncLayoutHeaderOffset();
        };
        const updateSaleCountdown = () => {
          const diff = endMs - Date.now();
          if (diff <= 0) {
            hideSaleBar();
            return;
          }
          if (!countdownEl) return;
          const days = Math.floor(diff / 86400000);
          const hours = Math.floor((diff % 86400000) / 3600000);
          const minutes = Math.floor((diff % 3600000) / 60000);
          const seconds = Math.floor((diff % 60000) / 1000);
          if (days > 0) {
            countdownEl.textContent = `${days}d ${pad(hours)}:${pad(minutes)}:${pad(seconds)}`;
          } else {
            countdownEl.textContent = `${pad(hours)}:${pad(minutes)}:${pad(seconds)}`;
          }
        };
        updateSaleCountdown();
        if (saleAnnouncementBar.classList.contains('hidden')) return;
        saleCountdownTimer = window.setInterval(updateSaleCountdown, 1000);
      };
      initSaleAnnouncementBar();
    */

    // A native <dialog>: showModal() keeps focus inside and the page inert,
    // Escape closes it, and closing returns focus to the search button. The
    // `close` event is the one place to tidy up, whichever way it closed.
    const openSearchModal = () => {
      if (!searchModal || searchModal.open) return;
      searchModal.showModal();
      document.body.style.overflow = 'hidden';
      openSearchButtons.forEach((button) => button.setAttribute('aria-expanded', 'true'));
      if (searchInput) {
        searchInput.focus();
        searchInput.select();
      }
    };

    const closeSearchModal = () => {
      if (searchModal && searchModal.open) searchModal.close();
    };

    openSearchButtons.forEach((button) => {
      button.addEventListener('click', openSearchModal);
    });
    closeSearchButtons.forEach((button) => button.addEventListener('click', closeSearchModal));

    if (searchModal) {
      searchModal.addEventListener('close', () => {
        document.body.style.overflow = '';
        openSearchButtons.forEach((button) => button.setAttribute('aria-expanded', 'false'));
      });

      // A click on the backdrop lands on the dialog itself, outside the panel.
      searchModal.addEventListener('click', (event) => {
        if (event.target.closest('[data-search-modal-panel]')) return;
        closeSearchModal();
      });
    }

    window.addEventListener('scroll', toggleHeaderTopStrip, { passive: true });
    toggleHeaderTopStrip();

    // Remembered per page for the inline script after </header>, which hides
    // the strip on reload or back/forward before the restored page paints.
    if (headerTopStrips.length) {
      window.addEventListener('pagehide', () => {
        const key = `luvora:top-strip-hidden:${location.pathname}`;
        try {
          if (headerTopStrips[0].classList.contains('is-hidden')) {
            sessionStorage.setItem(key, '1');
          } else {
            sessionStorage.removeItem(key);
          }
        } catch (e) {}
      });
    }

    // ─── Desktop dropdown triggers without a link ─────────────────────────────
    // Hover and focus open the drawer in CSS. A click toggles it: a mouse click
    // closes the drawer it just hovered open, a tap opens the closed one. Mouse
    // clicks drop focus either way, so leaving the item always closes it.
    document.querySelectorAll('[data-nav-dismiss-trigger]').forEach((trigger) => {
      const item = trigger.closest('.header-nav-item');
      const drawer = item && item.querySelector('.header-nav-drawer');
      if (!drawer) return;
      let wasOpen = false;
      let pointerType = '';

      trigger.addEventListener('pointerdown', (event) => {
        wasOpen = getComputedStyle(drawer).visibility === 'visible';
        pointerType = event.pointerType;
      });

      // Mirrors the CSS that shows the drawer. Deferred a frame so :hover and
      // :focus-within have settled after the event that changed them.
      const syncExpanded = () => {
        requestAnimationFrame(() => {
          const open = (item.matches(':hover') || item.matches(':focus-within')) && !item.classList.contains('is-dismissed');
          trigger.setAttribute('aria-expanded', String(open));
        });
      };

      trigger.addEventListener('click', (event) => {
        const open = event.detail === 0 ? !item.classList.contains('is-dismissed') : wasOpen;
        item.classList.toggle('is-dismissed', open);
        if (event.detail !== 0 && (open || pointerType === 'mouse')) trigger.blur();
        syncExpanded();
      });

      item.addEventListener('mouseenter', syncExpanded);
      item.addEventListener('focusin', syncExpanded);
      item.addEventListener('mouseleave', () => {
        item.classList.remove('is-dismissed');
        syncExpanded();
      });
      item.addEventListener('focusout', (event) => {
        if (!item.contains(event.relatedTarget) && !item.matches(':hover')) item.classList.remove('is-dismissed');
        syncExpanded();
      });

      // Escape closes a drawer opened by hover or focus, without moving the
      // pointer away. Focus inside it returns to the trigger.
      document.addEventListener('keydown', (event) => {
        if (event.key !== 'Escape' || trigger.getAttribute('aria-expanded') !== 'true') return;
        item.classList.add('is-dismissed');
        if (item.contains(document.activeElement)) trigger.focus();
        syncExpanded();
      });
    });

    // ─── Swipe to close ───────────────────────────────────────────────────────
    // A drawer follows the finger once a touch is clearly sideways and heading
    // for the edge it came in from (`side`: -1 left, 1 right), so scrolling it
    // is left alone. Let go past a third of its width, or flick, and `close`
    // runs; otherwise it springs back. Clearing the inline styles hands the
    // motion back to the class transition. Touches that start in a field are
    // ignored so the text cursor can still be dragged.
    const addSwipeToClose = (drawer, backdrop, side, close) => {
      let swipe = null;

      drawer.addEventListener('touchstart', (e) => {
        if (e.touches.length !== 1 || e.target.closest('input, textarea')) return;
        const touch = e.touches[0];
        swipe = {
          x: touch.clientX,
          y: touch.clientY,
          dx: 0,
          time: e.timeStamp,
          width: drawer.offsetWidth,
          dragging: false,
        };
      }, { passive: true });

      drawer.addEventListener('touchmove', (e) => {
        if (!swipe) return;
        const touch = e.touches[0];
        const dx = touch.clientX - swipe.x;
        const dy = touch.clientY - swipe.y;
        if (!swipe.dragging) {
          if (Math.abs(dx) < 10 && Math.abs(dy) < 10) return;
          if (dx * side < 0 || Math.abs(dy) > Math.abs(dx)) {
            swipe = null;
            return;
          }
          swipe.dragging = true;
          drawer.style.transition = 'none';
          if (backdrop) backdrop.style.transition = 'none';
        }
        e.preventDefault();
        swipe.dx = side < 0 ? Math.min(0, dx) : Math.max(0, dx);
        drawer.style.transform = `translateX(${swipe.dx}px)`;
        if (backdrop) backdrop.style.opacity = String(1 - Math.abs(swipe.dx) / swipe.width);
      }, { passive: false });

      const endSwipe = (e) => {
        if (!swipe) return;
        const { dx, time, width, dragging } = swipe;
        swipe = null;
        if (!dragging) return;
        drawer.style.transition = '';
        drawer.style.transform = '';
        if (backdrop) {
          backdrop.style.transition = '';
          backdrop.style.opacity = '';
        }
        const distance = dx * side;
        const flicked = distance > 30 && distance / Math.max(1, e.timeStamp - time) > 0.5;
        if (e.type === 'touchend' && (distance > width / 3 || flicked)) close();
      };

      drawer.addEventListener('touchend', endSwipe);
      drawer.addEventListener('touchcancel', endSwipe);
    };

    // ─── Nav Drawer ───────────────────────────────────────────────────────────
    const navDrawerBackdrop = document.querySelector('[data-nav-drawer-backdrop]');
    const navDrawer = document.querySelector('[data-nav-drawer]');
    const openNavBtns = document.querySelectorAll('[data-open-nav-drawer]');
    const closeNavBtns = document.querySelectorAll('[data-close-nav-drawer]');

    if (navDrawer) {
      const isNavDrawerOpen = () => !navDrawer.classList.contains('-translate-x-full');
      let navDrawerOpener = null;

      const openNavDrawer = (event) => {
        navDrawerOpener = event.currentTarget;
        navDrawer.inert = false;
        if (navDrawerBackdrop) navDrawerBackdrop.classList.remove('opacity-0', 'pointer-events-none');
        navDrawer.classList.remove('-translate-x-full');
        document.body.style.overflow = 'hidden';
        openNavBtns.forEach((btn) => btn.setAttribute('aria-expanded', 'true'));
        if (closeNavBtns[0]) closeNavBtns[0].focus({ preventScroll: true });
      };

      const closeNavDrawer = ({ restoreFocus = true } = {}) => {
        if (!isNavDrawerOpen()) return;
        if (navDrawerBackdrop) navDrawerBackdrop.classList.add('opacity-0', 'pointer-events-none');
        navDrawer.classList.add('-translate-x-full');
        navDrawer.inert = true;
        document.body.style.overflow = '';
        openNavBtns.forEach((btn) => btn.setAttribute('aria-expanded', 'false'));
        if (restoreFocus && navDrawerOpener) navDrawerOpener.focus({ preventScroll: true });
      };

      openNavBtns.forEach((btn) => btn.addEventListener('click', openNavDrawer));
      closeNavBtns.forEach((btn) => btn.addEventListener('click', () => closeNavDrawer()));
      if (navDrawerBackdrop) navDrawerBackdrop.addEventListener('click', () => closeNavDrawer());

      window.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && isNavDrawerOpen()) closeNavDrawer();
      });

      addSwipeToClose(navDrawer, navDrawerBackdrop, -1, () => closeNavDrawer());

      // The FAQ row reads "FAQ" wherever its full label would wrap in the icon
      // grid. Measured rather than set by breakpoint, since the cell width
      // follows the viewport and the label's width follows the font. The full
      // label stays for screen readers. Without the script it simply wraps.
      const navFitLabels = navDrawer.querySelectorAll('[data-label-full]');
      const fitNavLabels = () => {
        navFitLabels.forEach((full) => {
          const short = full.nextElementSibling;
          full.classList.remove('sr-only');
          const wraps = full.getClientRects().length > 1;
          full.classList.toggle('sr-only', wraps);
          if (short) short.hidden = !wraps;
        });
      };

      if (navFitLabels.length) {
        const navFitObserver = new ResizeObserver(fitNavLabels);
        navFitLabels.forEach((full) => navFitObserver.observe(full.closest('a')));
        document.fonts.ready.then(fitNavLabels);
      }

      // Keep Tab inside the open drawer. The close button and the FAQ link are
      // always the first and last focusable elements, whether Smykker is open or not.
      navDrawer.addEventListener('keydown', (e) => {
        if (e.key !== 'Tab') return;
        const focusable = navDrawer.querySelectorAll('a[href], button, input, summary');
        const first = focusable[0];
        const last = focusable[focusable.length - 1];
        if (e.shiftKey && document.activeElement === first) {
          e.preventDefault();
          last.focus();
        } else if (!e.shiftKey && document.activeElement === last) {
          e.preventDefault();
          first.focus();
        }
      });

      // Smykker slides open and shut. The click is handled here rather than in
      // a `toggle` listener, which fires a frame late and would flash the full
      // panel first. Closing keeps `open` until the panel has folded away;
      // `is-closing` swaps the icon back to + straight away. A click halfway
      // through reverses from the panel's current height.
      const navReduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      navDrawer.querySelectorAll('details').forEach((details) => {
        const summary = details.querySelector('summary');
        const panel = details.querySelector('[data-nav-accordion-panel]');
        if (!summary || !panel) return;
        let expanded = details.open;
        let animation = null;

        summary.addEventListener('click', (e) => {
          e.preventDefault();
          const fromHeight = details.open ? panel.offsetHeight : 0;
          const fromOpacity = details.open ? getComputedStyle(panel).opacity : '0';
          expanded = !expanded;
          if (animation) animation.cancel();
          animation = null;
          details.classList.toggle('is-closing', !expanded);

          if (navReduceMotion.matches) {
            details.classList.remove('is-closing');
            details.open = expanded;
            return;
          }

          details.open = true;
          const toHeight = expanded ? panel.offsetHeight : 0;
          const current = panel.animate(
            [
              { height: `${fromHeight}px`, opacity: fromOpacity },
              { height: `${toHeight}px`, opacity: expanded ? 1 : 0 },
            ],
            { duration: 260, easing: 'cubic-bezier(0.25, 0.8, 0.35, 1)', fill: 'forwards' }
          );
          animation = current;
          current.onfinish = () => {
            if (!expanded) {
              details.open = false;
              details.classList.remove('is-closing');
            }
            current.cancel();
            animation = null;
          };
        });
      });

      // The menu button is gone from lg up, so an open drawer would be stranded
      // there with the page scroll locked.
      const navDesktopQuery = window.matchMedia('(min-width: 1024px)');
      navDesktopQuery.addEventListener('change', (e) => {
        if (e.matches) closeNavDrawer({ restoreFocus: false });
      });

      // Back from a page opened in the drawer restores this one from the
      // back/forward cache with the drawer still open and scroll locked.
      window.addEventListener('pageshow', (e) => {
        if (e.persisted) closeNavDrawer({ restoreFocus: false });
      });
    }

    // ─── Cart Drawer ───────────────────────────────────────────────────────────
    const cartDrawerBackdrop = document.querySelector('[data-cart-drawer-backdrop]');
    const cartDrawer = document.querySelector('[data-cart-drawer]');
    const cartDrawerItemsEl = document.querySelector('[data-cart-drawer-items]');
    const cartPageItemsEl = document.querySelector('[data-cart-page-items]');
    const openCartBtns = document.querySelectorAll('[data-open-cart-drawer]');
    const closeCartBtns = document.querySelectorAll('[data-close-cart-drawer]');
    const cartBadgeEl = document.querySelector('[data-cart-badge]');

    if (cartDrawer) {
      const isCartPage = () => document.body.classList.contains('template-cart');
      const sectionName = cartDrawer.dataset.sectionName || 'cart-drawer-items';
      const cartJsonUrl = cartDrawer.dataset.cartJsonUrl || '/cart.js';
      const cartChangeUrl = cartDrawer.dataset.cartChangeUrl || '/cart/change.js';
      const cartUpdateUrl = cartDrawer.dataset.cartUpdateUrl || '/cart/update.js';
      const cartPageUrl = cartDrawer.dataset.cartUrl || '/cart';
      const errMessage = cartDrawer.dataset.errorMessage || '';
      const errCta = cartDrawer.dataset.errorCta || '';
      const errUpdate = cartDrawer.dataset.errorUpdate || errMessage;
      const discountErrFallback = cartDrawer.dataset.discountErrorFallback || '';
      const discountErrEmpty = cartDrawer.dataset.discountEmpty || '';

      let cartDrawerFooterEl = document.querySelector('[data-cart-drawer-footer]');

      const esc = (s) =>
        String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');

      const setBadge = (count) => {
        if (!cartBadgeEl) return;
        cartBadgeEl.textContent = count;
        cartBadgeEl.classList.toggle('hidden', count === 0);
      };

      const refreshDrawerFromSection = async () => {
        const url = new URL(window.location.href);
        url.searchParams.set('sections', sectionName);
        const res = await fetch(url.toString());
        if (!res.ok) throw new Error('section fetch failed');
        const payload = await res.json();
        const html = payload[sectionName];
        if (!html || typeof html !== 'string') throw new Error('missing section html');
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const itemsFrag = doc.querySelector('[data-cart-drawer-ajax-items]');
        const newFooter = doc.querySelector('[data-cart-drawer-footer]');
        if (itemsFrag && cartDrawerItemsEl) cartDrawerItemsEl.innerHTML = itemsFrag.innerHTML;
        if (newFooter && cartDrawerFooterEl) {
          cartDrawerFooterEl.replaceWith(document.importNode(newFooter, true));
          cartDrawerFooterEl = document.querySelector('[data-cart-drawer-footer]');
        }
      };

      const formatDiscountApiMessage = (data) => {
        if (!data) return '';
        const raw = data.description != null ? data.description : data.message;
        if (typeof raw === 'string') return raw;
        if (Array.isArray(raw)) return raw.filter(Boolean).join(', ');
        return '';
      };

      // The updaters below refresh the drawer themselves before announcing the
      // change. The cart:updated listener reads this flag synchronously, so it
      // does not fetch the drawer a second time and wipe what was just shown.
      let drawerAlreadyRefreshed = false;
      const announceCartUpdated = (cart) => {
        drawerAlreadyRefreshed = true;
        try {
          document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
        } finally {
          drawerAlreadyRefreshed = false;
        }
      };

      const isDiscountApplied = (data, code) => {
        const codes = data && Array.isArray(data.discount_codes) ? data.discount_codes : null;
        if (!codes) return true;
        const wanted = code.toLowerCase();
        return codes.some(
          (dc) => dc && typeof dc.code === 'string' && dc.code.toLowerCase() === wanted && dc.applicable !== false
        );
      };

      const setDiscountError = (scope, message) => {
        if (!scope) return;
        const errEl = scope.querySelector('[data-cart-discount-error]');
        const panel = scope.querySelector('[data-cart-discount-panel]');
        const toggle = scope.querySelector('[data-cart-discount-toggle]');
        if (errEl) {
          errEl.textContent = message;
          errEl.classList.toggle('hidden', !message);
        }
        if (panel && message) panel.classList.remove('hidden');
        if (toggle && message) toggle.setAttribute('aria-expanded', 'true');
      };

      const clearDiscountError = (scope) => {
        if (!scope) return;
        const errEl = scope.querySelector('[data-cart-discount-error]');
        if (errEl) {
          errEl.textContent = '';
          errEl.classList.add('hidden');
        }
      };

      // `scope` is the [data-cart-discount] the customer used: the drawer's or the cart page's.
      // `isRemoval` posts the codes left after removing one, which need no rejection check.
      const applyCartDiscount = async (rawCode, scope, isRemoval = false) => {
        const code = typeof rawCode === 'string' ? rawCode.trim() : '';
        let rejected = false;
        let reloading = false;
        clearDiscountError(scope);
        if (cartDrawerItemsEl) cartDrawerItemsEl.style.opacity = '0.5';
        if (cartDrawerFooterEl) cartDrawerFooterEl.style.opacity = '0.5';
        if (scope) scope.style.opacity = '0.5';
        try {
          const res = await fetch(cartUpdateUrl, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ discount: code }),
          });
          const text = await res.text();
          let data = null;
          try {
            data = text ? JSON.parse(text) : null;
          } catch (_) {
            data = { message: text };
          }
          if (!res.ok) {
            const msg = formatDiscountApiMessage(data) || discountErrFallback;
            throw new Error(msg);
          }
          // A code Shopify cannot apply still comes back 200: it is listed in
          // discount_codes with applicable false (or not at all). The cart has
          // been updated either way, so the drawer is refreshed before the error.
          rejected = !isRemoval && code !== '' && !isDiscountApplied(data, code);
          if (!isCartPage()) {
            await refreshDrawerFromSection();
          }
          setBadge(data && typeof data.item_count === 'number' ? data.item_count : 0);
          announceCartUpdated(data);
          if (rejected) throw new Error(discountErrFallback);
          if (isCartPage()) {
            reloading = true;
            window.location.reload();
          }
        } catch (err) {
          const msg = err && err.message ? err.message : discountErrFallback;
          // The drawer refresh replaced the footer, so the error goes on the new copy.
          const target = scope && scope.isConnected ? scope : cartDrawerFooterEl;
          setDiscountError(target, msg);
          if (rejected && target) {
            const input = target.querySelector('[data-cart-discount-input]');
            if (input && !input.value) input.value = code;
          }
        } finally {
          // The cart page stays dimmed until the reload replaces it.
          if (!reloading) {
            if (cartDrawerItemsEl) cartDrawerItemsEl.style.opacity = '1';
            if (cartDrawerFooterEl) cartDrawerFooterEl.style.opacity = '1';
            if (scope) scope.style.opacity = '1';
          }
        }
      };

      // Quantity changes. Fast clicks add up in the row and go out as one
      // change per line once the clicks stop. While the cart is dimmed the
      // buttons ignore clicks: a change is loading, and clicks landing on a
      // half-updated cart kept sending the wrong quantity. (Clicks used to
      // send overlapping changes, and the loser replaced the drawer with the
      // load error.)
      const QTY_SETTLE_MS = 400;
      const wantedQty = new Map();
      let settleTimer = null;
      let flushing = false;

      // A row's two buttons hold quantity − 1 and quantity + 1.
      const renderedQty = (btn) => {
        const pair = Array.from(btn.parentElement.querySelectorAll('.cart-qty'))
          .map((b) => parseInt(b.dataset.qty, 10))
          .filter(Number.isFinite);
        return pair.length === 2 ? Math.min(...pair) + 1 : NaN;
      };
      const showWantedQty = (btn, qty) => {
        const label = btn.parentElement.querySelector('span');
        if (label) label.textContent = qty;
      };
      const setCartBusy = (busy) => {
        [cartDrawerItemsEl, cartPageItemsEl].forEach((el) => {
          if (!el) return;
          el.style.opacity = busy ? '0.5' : '1';
          el.style.pointerEvents = busy ? 'none' : '';
        });
      };

      const postCartChange = async (key, qty, retried = false) => {
        const res = await fetch(cartChangeUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: key, quantity: qty }),
        });
        // Shopify throttles bursts with 429; one patient retry covers it.
        if (res.status === 429 && !retried) {
          await new Promise((resolve) => setTimeout(resolve, 800));
          return postCartChange(key, qty, true);
        }
        const cart = await res.json().catch(() => null);
        if (!res.ok || !cart) throw new Error('cart change failed');
        return cart;
      };

      const flushQty = async () => {
        settleTimer = null;
        if (flushing || !wantedQty.size) return;
        flushing = true;
        setCartBusy(true);
        let cart = null;
        // The cart page stays dimmed until the reload replaces it; undimming
        // first showed the old rows again, a removed line included.
        let reloading = false;
        try {
          for (const [key, qty] of Array.from(wantedQty)) {
            try {
              cart = await postCartChange(key, qty);
            } catch (_) {
              // Leave the line as Shopify has it; the redraw shows that.
            }
          }
          wantedQty.clear();
          if (isCartPage()) {
            reloading = true;
            window.location.reload();
            return;
          }
          await refreshDrawerFromSection();
          const fresh = cart || (await fetchCart());
          setBadge(typeof fresh.item_count === 'number' ? fresh.item_count : 0);
          announceCartUpdated(fresh);
        } catch (_) {
          showDrawerError();
        } finally {
          if (!reloading) {
            flushing = false;
            setCartBusy(false);
          }
        }
      };

      const stepQty = (btn) => {
        if (flushing) return;
        const key = btn.dataset.key;
        const target = parseInt(btn.dataset.qty, 10);
        const rendered = renderedQty(btn);
        if (!Number.isFinite(target)) return;
        const base = wantedQty.has(key) ? wantedQty.get(key) : rendered;
        const next = Number.isFinite(base) ? Math.max(0, base + (target - rendered)) : target;
        wantedQty.set(key, next);
        showWantedQty(btn, next);
        clearTimeout(settleTimer);
        settleTimer = setTimeout(flushQty, QTY_SETTLE_MS);
      };

      const removeLine = (key) => {
        if (flushing) return;
        wantedQty.set(key, 0);
        clearTimeout(settleTimer);
        flushQty();
      };

      const showCartPageError = () => {
        const errEl = document.querySelector('[data-cart-page-error]');
        if (!errEl) return;
        errEl.textContent = errUpdate;
        errEl.classList.remove('hidden');
      };

      document.addEventListener('click', (e) => {
        const qtyBtn = e.target.closest('.cart-qty');
        if (qtyBtn && qtyBtn.dataset.key) {
          if (!qtyBtn.closest('[data-cart-drawer-items], [data-cart-page-items]')) return;
          e.preventDefault();
          stepQty(qtyBtn);
          return;
        }
        const remBtn = e.target.closest('.cart-remove');
        if (remBtn && remBtn.dataset.key) {
          if (!remBtn.closest('[data-cart-drawer-items], [data-cart-page-items]')) return;
          e.preventDefault();
          removeLine(remBtn.dataset.key);
        }

        const discountScope = e.target.closest('[data-cart-discount]');
        if (!discountScope) return;

        const discToggle = e.target.closest('[data-cart-discount-toggle]');
        if (discToggle) {
          e.preventDefault();
          const panel = discountScope.querySelector('[data-cart-discount-panel]');
          if (!panel) return;
          clearDiscountError(discountScope);
          panel.classList.toggle('hidden');
          const open = !panel.classList.contains('hidden');
          discToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
          if (open) {
            const input = discountScope.querySelector('[data-cart-discount-input]');
            if (input) input.focus();
          }
          return;
        }

        const discApply = e.target.closest('[data-cart-discount-apply]');
        if (discApply) {
          e.preventDefault();
          const input = discountScope.querySelector('[data-cart-discount-input]');
          const val = input && input.value ? input.value.trim() : '';
          if (!val) {
            setDiscountError(discountScope, discountErrEmpty);
            return;
          }
          applyCartDiscount(val, discountScope);
          return;
        }

        const discRemove = e.target.closest('[data-cart-discount-remove]');
        if (discRemove) {
          e.preventDefault();
          // The Ajax API replaces the cart's codes with the list it is sent.
          const removed = discRemove.dataset.cartDiscountRemove;
          const remaining = Array.from(discountScope.querySelectorAll('[data-cart-discount-code]'))
            .map((el) => el.dataset.cartDiscountCode)
            .filter((c) => c && c !== removed);
          applyCartDiscount(remaining.join(','), discountScope, true);
        }
      });

      document.addEventListener('keydown', (e) => {
        if (e.key !== 'Enter') return;
        const input = e.target.closest('[data-cart-discount-input]');
        if (!input) return;
        const discountScope = input.closest('[data-cart-discount]');
        if (!discountScope) return;
        e.preventDefault();
        const val = input.value ? input.value.trim() : '';
        if (!val) {
          setDiscountError(discountScope, discountErrEmpty);
          return;
        }
        applyCartDiscount(val, discountScope);
      });

      const fetchCart = () => fetch(cartJsonUrl).then((r) => r.json());

      const showDrawerError = () => {
        if (!cartDrawerItemsEl) return;
        cartDrawerItemsEl.innerHTML = `
          <div class="flex min-h-full flex-col items-center justify-center py-16 gap-4 text-center">
            <p class="text-sm text-slate-500">${esc(errMessage)}</p>
            <a href="${esc(cartPageUrl)}" class="text-xs uppercase tracking-label text-luvora-primary border-b border-luvora-primary pb-0.5 transition-opacity hover:opacity-70">${esc(
              errCta
            )}</a>
          </div>`;
        if (cartDrawerFooterEl) cartDrawerFooterEl.classList.add('hidden');
      };

      const openDrawer = () => {
        if (isCartPage()) return;
        if (cartDrawerBackdrop) cartDrawerBackdrop.classList.remove('opacity-0', 'pointer-events-none');
        cartDrawer.classList.remove('translate-x-full');
        document.body.style.overflow = 'hidden';
      };

      const closeDrawer = () => {
        if (cartDrawerBackdrop) cartDrawerBackdrop.classList.add('opacity-0', 'pointer-events-none');
        cartDrawer.classList.add('translate-x-full');
        document.body.style.overflow = '';
      };

      openCartBtns.forEach((btn) => btn.addEventListener('click', openDrawer));
      closeCartBtns.forEach((btn) => btn.addEventListener('click', closeDrawer));
      if (cartDrawerBackdrop) cartDrawerBackdrop.addEventListener('click', closeDrawer);
      addSwipeToClose(cartDrawer, cartDrawerBackdrop, 1, closeDrawer);

      window.addEventListener('keydown', (e) => {
        if (isCartPage()) return;
        if (e.key === 'Escape' && !cartDrawer.classList.contains('translate-x-full')) closeDrawer();
      });

      document.addEventListener('cart:open', async () => {
        try {
          const cart = await fetchCart();
          setBadge(cart.item_count);
          if (isCartPage()) return;
          openDrawer();
          await refreshDrawerFromSection();
        } catch (_) {
          if (!isCartPage()) showDrawerError();
        }
      });

      document.addEventListener('cart:updated', async (e) => {
        const alreadyRefreshed = drawerAlreadyRefreshed;
        let cart = e.detail;
        if (!cart) {
          try {
            cart = await fetchCart();
          } catch {
            return;
          }
        }
        setBadge(cart.item_count);
        if (!alreadyRefreshed && !cartDrawer.classList.contains('translate-x-full')) {
          try {
            await refreshDrawerFromSection();
          } catch {
            showDrawerError();
          }
        }
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const trigger = document.querySelector('[data-home-scroll-categories]');
    const target = document.querySelector('[data-home-categories]');
    if (!trigger || !target) return;

    function getHeaderOffset() {
      const raw = getComputedStyle(document.documentElement).getPropertyValue('--luvora-layout-header-offset');
      const parsed = parseFloat(raw);
      return Number.isFinite(parsed) ? parsed : 120;
    }

    // The link works on its own; this lands the section below the sticky
    // header instead of under it, and moves focus there for keyboard users.
    trigger.addEventListener('click', function (event) {
      event.preventDefault();
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const top = target.getBoundingClientRect().top + window.scrollY - getHeaderOffset();

      window.scrollTo({
        top: top,
        behavior: reducedMotion ? 'auto' : 'smooth',
      });
      target.focus({ preventScroll: true });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["loose-diamond"]) return;
  try {
    
  (() => {
    // Keep in step with diamondPrice in luvora-backend's
    // extensions/option-price-transform/src/run.js: same lookup, same step
    // order, same rounding to 10 kr. The cart charges what that function says.
    const SPECS = ['Slipeform', 'Carat', 'Farge', 'Slip', 'Klarhet'];
    const STEPS = ['Farge', 'Slip', 'Klarhet'];
    const own = (object, key) =>
      typeof key === 'string' && Object.prototype.hasOwnProperty.call(object, key);

    const diamondPrice = (table, specs) => {
      const index = (table.carats || []).indexOf(specs.Carat);
      const shapes = table.shapes || {};
      const bases = own(shapes, specs.Slipeform) ? shapes[specs.Slipeform] : null;
      if (index < 0 || !Array.isArray(bases)) return null;
      let price = Number(bases[index]);
      if (!(price > 0)) return null;
      for (const group of STEPS) {
        const steps = (table.steps && table.steps[group]) || {};
        const step = own(steps, specs[group]) ? steps[specs[group]] : null;
        if (typeof step !== 'number' || !Number.isFinite(step)) return null;
        price *= 1 + step / 100;
      }
      return Math.round(price / 10) * 10;
    };

    // The options app block's formatter: whole amounts drop their decimals.
    const MONEY_MAP = {
      amount_no_decimals: [0],
      amount_with_comma_separator: [2, '.', ','],
      amount_no_decimals_with_comma_separator: [0, '.', ','],
      amount_with_apostrophe_separator: [2, "'", '.'],
      amount_no_decimals_with_space_separator: [0, ' ', '.'],
      amount_with_space_separator: [2, ' ', ','],
      amount_with_period_and_space_separator: [2, ' ', '.'],
    };
    const delimit = (cents, places = 2, thousands = ',', decimal = '.') => {
      const [whole, fraction] = (Math.abs(cents) / 100).toFixed(places).split('.');
      const grouped = whole.replace(/(\d)(?=(\d\d\d)+(?!\d))/g, `$1${thousands}`);
      return (cents < 0 ? '-' : '') + grouped + (places && fraction ? decimal + fraction : '');
    };
    const formatMoney = (cents, format) => {
      const match = (format || '').match(/\{\{\s*(\w+)\s*\}\}/);
      if (!match) return String(cents / 100);
      const [places = 2, thousands, decimal] = MONEY_MAP[match[1]] || [];
      const shown = cents % 100 === 0 ? 0 : places;
      return format.replace(match[0], delimit(cents, shown, thousands, decimal));
    };

    const TIER_ACTIVE = ['border-luvora-primary', 'bg-luvora-primary', 'text-luvora-on-primary'];
    const TIER_IDLE = ['border-transparent', 'bg-luvora-paper', 'text-luvora-ink'];

    const init = (root) => {
      const tableEl = root.querySelector('[data-ld-table]');
      const form = root.querySelector('[data-ld-form]');
      if (!tableEl || !form) return;

      let table;
      try {
        table = JSON.parse(tableEl.textContent);
      } catch (_) {
        return;
      }

      const moneyFormat = root.dataset.moneyFormat;
      const productId = Number(root.dataset.productId);
      let cartCount = Number(root.dataset.cartCount) || 0;

      const quantityInput = form.querySelector('[data-ld-quantity]');
      const submit = form.querySelector('[data-ld-submit]');
      const error = form.querySelector('[data-ld-error]');
      const unitEl = root.querySelector('[data-ld-unit]');
      const totalEl = root.querySelector('[data-ld-total]');
      const totalOriginalEl = root.querySelector('[data-ld-total-original]');
      const totalLabel = root.querySelector('[data-ld-total-label]');
      const unitLine = root.querySelector('[data-ld-unit-line]');
      const unitPlaceholder = root.querySelector('[data-ld-unit-placeholder]');
      const unitOriginalEl = root.querySelector('[data-ld-unit-original]');
      const nudgeEl = root.querySelector('[data-ld-nudge]');
      const nudgeRow = root.querySelector('[data-ld-nudge-row]');
      const nudgeBar = root.querySelector('[data-ld-nudge-bar]');
      const inCartEl = root.querySelector('[data-ld-in-cart]');
      const summaryEl = root.querySelector('[data-ld-summary]');
      const visuals = root.querySelectorAll('[data-ld-visual]');
      const scaleEl = root.querySelector('[data-ld-scale]');
      const maxCarat = parseFloat((table.carats || []).slice(-1)[0]);

      const tiers = Array.from(root.querySelectorAll('[data-ld-tier]'))
        .map((el) => ({ el, min: Number(el.dataset.min), percent: Number(el.dataset.percent) }))
        .filter((tier) => tier.min > 0 && tier.percent > 0)
        .sort((a, b) => a.min - b.min);

      const quantity = () => {
        const value = Math.round(Number(quantityInput.value));
        const max = Number(quantityInput.max) || 50;
        return Number.isFinite(value) ? Math.min(Math.max(value, 1), max) : 1;
      };

      const specs = () => {
        const picked = {};
        for (const name of SPECS) {
          picked[name] = form.querySelector(`[name="properties[${name}]"]:checked`)?.value;
        }
        return picked;
      };

      const fill = (template, values) =>
        Object.entries(values).reduce((text, [key, value]) => text.split(`[${key}]`).join(value), template || '');
      // Elements carrying data-one / data-other plural templates.
      const plural = (el, count) => fill(count === 1 ? el.dataset.one : el.dataset.other, { count });

      const render = () => {
        const picked = specs();
        const count = quantity();
        const price = diamondPrice(table, picked);

        summaryEl.textContent = SPECS.map((name) => picked[name]).filter(Boolean).join(' • ');
        visuals.forEach((el) => {
          el.hidden = el.dataset.ldVisual !== picked.Slipeform;
        });
        const carat = parseFloat(picked.Carat);
        if (scaleEl && carat > 0 && maxCarat > 0) {
          scaleEl.style.transform = `scale(${Math.cbrt(Math.min(carat / maxCarat, 1)).toFixed(3)})`;
        }

        const stones = cartCount + count;
        const current = tiers.filter((tier) => tier.min <= stones).pop();
        const next = tiers.find((tier) => tier.min > stones);

        tiers.forEach((tier) => {
          TIER_ACTIVE.forEach((cls) => tier.el.classList.toggle(cls, tier === current));
          TIER_IDLE.forEach((cls) => tier.el.classList.toggle(cls, tier !== current));
        });

        if (nudgeEl) {
          if (next) {
            nudgeEl.textContent = fill(nudgeEl.dataset.nudgeTemplate, {
              count: next.min - stones,
              percent: next.percent,
            });
          } else if (current && price != null) {
            // The top tier: say what the discount is worth on this selection.
            const saved = price * 100 * count - Math.round(price * 100 * count * (1 - current.percent / 100));
            nudgeEl.textContent = fill(nudgeEl.dataset.reachedTemplate, { amount: formatMoney(saved, moneyFormat) });
          } else {
            nudgeEl.textContent = '';
          }
          if (nudgeRow) nudgeRow.hidden = !nudgeEl.textContent;
          if (nudgeBar) {
            nudgeBar.hidden = !nudgeEl.textContent;
            nudgeBar.querySelector('[data-ld-nudge-bar-text]').textContent = nudgeEl.textContent;
          }
        }
        if (inCartEl) {
          inCartEl.hidden = cartCount < 1;
          inCartEl.textContent = fill(inCartEl.dataset.template, { count: cartCount });
        }
        if (totalLabel) totalLabel.textContent = plural(totalLabel, count);
        unitLine?.classList.toggle('invisible', count < 2);
        unitPlaceholder?.classList.toggle('invisible', count >= 2);

        if (price == null) {
          submit.disabled = true;
          return;
        }
        submit.disabled = false;

        const unitCents = price * 100;
        const factor = current ? 1 - current.percent / 100 : 1;
        const discountedUnit = Math.round(unitCents * factor);
        const discountedTotal = Math.round(unitCents * count * factor);

        unitEl.textContent = formatMoney(discountedUnit, moneyFormat);
        totalEl.textContent = formatMoney(discountedTotal, moneyFormat);
        totalOriginalEl.classList.toggle('invisible', !current);
        totalOriginalEl.textContent = current ? formatMoney(unitCents * count, moneyFormat) : '\u00a0';
        if (unitOriginalEl) {
          unitOriginalEl.classList.toggle('invisible', !current || count < 2);
          unitOriginalEl.textContent = current ? formatMoney(unitCents, moneyFormat) : '\u00a0';
        }
      };

      form.addEventListener('change', render);
      quantityInput.addEventListener('input', render);
      quantityInput.addEventListener('blur', () => {
        quantityInput.value = quantity();
        render();
      });
      form.querySelectorAll('[data-ld-step]').forEach((button) => {
        button.addEventListener('click', () => {
          quantityInput.value = Math.min(
            Math.max(quantity() + Number(button.dataset.ldStep), 1),
            Number(quantityInput.max) || 50,
          );
          render();
        });
      });

      const refreshCartCount = async () => {
        try {
          const res = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
          if (!res.ok) return;
          const cart = await res.json();
          cartCount = cart.items
            .filter((item) => item.product_id === productId)
            .reduce((sum, item) => sum + item.quantity, 0);
          render();
        } catch (_) {
          // The count from page load stays; the discounts in the cart are what count.
        }
      };
      document.addEventListener('cart:updated', refreshCartCount);
      window.addEventListener('pageshow', (event) => {
        if (event.persisted) refreshCartCount();
      });

      form.addEventListener('submit', async (event) => {
        event.preventDefault();
        quantityInput.value = quantity();
        submit.disabled = true;
        error.hidden = true;
        try {
          const res = await fetch('/cart/add.js', {
            method: 'POST',
            body: new FormData(form),
            headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          });
          if (!res.ok) throw new Error('add failed');
          cartCount += quantity();
          quantityInput.value = 1;
          document.dispatchEvent(new CustomEvent('cart:open'));
        } catch (_) {
          error.hidden = false;
        } finally {
          render();
        }
      });

      render();
      // Animate size changes from here on, not the jump from full size on load.
      requestAnimationFrame(() => {
        scaleEl?.classList.add('transition-transform', 'duration-300', 'ease-out');
      });
    };

    document.querySelectorAll('[data-loose-diamond]').forEach(init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  (() => {
    const form = document.getElementById('luvora-product-form');
    if (!form) return;

    const stickyAtc = document.querySelector('[data-product-sticky-atc]');
    const consentInput = form.querySelector('[data-product-custom-size-consent]');

    const modal = document.querySelector('[data-product-custom-size-modal]');
    const modalConfirm = modal?.querySelector('[data-product-custom-size-confirm]');
    const modalCancel = modal?.querySelector('[data-product-custom-size-cancel]');
    const modalAccept = modal?.querySelector('[data-product-custom-size-accept]');

    // ─── Is a custom (Tilpasset) size selected? ──────────────────────────────
    // The options app owns Størrelse and reports it on every change, including
    // the initial render, so this never needs to read the DOM.
    const SIZE_GROUP = 'Størrelse';
    const CUSTOM_SIZE_PATTERN = /tilpasset|custom/i;
    let customSizeSelected = false;

    const setConsent = (granted) => {
      if (consentInput) consentInput.disabled = !granted;
    };

    document.addEventListener('product-options:change', (event) => {
      const selections = (event.detail && event.detail.selections) || [];
      const size = selections.find((s) => s && s.groupName === SIZE_GROUP);
      const next = !!(size && size.label && CUSTOM_SIZE_PATTERN.test(size.label));
      if (next === customSizeSelected) return;
      customSizeSelected = next;
      // Consent is specific to the size that was confirmed — moving off
      // Tilpasset (or onto a different custom value) revokes it.
      setConsent(false);
    });

    // ─── Confirmation dialog ─────────────────────────────────────────────────
    const resetModal = () => {
      // returnValue survives from the last close, and Escape closes without
      // setting it, so a previous 'confirm' would otherwise count as consent.
      if (modal) modal.returnValue = '';
      if (modalAccept) modalAccept.checked = false;
      if (modalConfirm) modalConfirm.disabled = true;
    };

    modalAccept?.addEventListener('change', () => {
      if (modalConfirm) modalConfirm.disabled = !modalAccept.checked;
    });

    const askCustomSizeConfirm = () =>
      new Promise((resolve) => {
        if (!modal || typeof modal.showModal !== 'function') {
          resolve(true);
          return;
        }

        let settled = false;
        const finish = (confirmed) => {
          if (settled) return;
          settled = true;
          modal.removeEventListener('close', onClose);
          modalConfirm?.removeEventListener('click', onConfirm);
          modalCancel?.removeEventListener('click', onCancel);
          modal.removeEventListener('click', onBackdrop);
          resolve(confirmed);
        };

        const onConfirm = () => {
          if (modalAccept && !modalAccept.checked) return;
          modal.close('confirm');
        };

        const onCancel = () => {
          modal.close('cancel');
        };

        const onClose = () => {
          finish(modal.returnValue === 'confirm');
        };

        const onBackdrop = (event) => {
          if (event.target === modal) modal.close('cancel');
        };

        resetModal();
        modal.addEventListener('close', onClose);
        modalConfirm?.addEventListener('click', onConfirm);
        modalCancel?.addEventListener('click', onCancel);
        modal.addEventListener('click', onBackdrop);
        modal.showModal();
      });

    // ─── Add to cart ─────────────────────────────────────────────────────────
    const openCartDrawer = () => {
      document.dispatchEvent(new CustomEvent('cart:open'));
    };

    const addToCartAjax = async () => {
      if (stickyAtc) stickyAtc.disabled = true;

      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          body: new FormData(form),
          headers: {
            Accept: 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
          },
        });
        if (!res.ok) throw new Error('add failed');

        openCartDrawer();
      } catch (_) {
        form.removeEventListener('submit', handleSubmit);
        form.submit();
      } finally {
        if (stickyAtc) stickyAtc.disabled = false;
        // One confirmation covers one add; the next add must be confirmed again.
        setConsent(false);
      }
    };

    const handleSubmit = async (event) => {
      event.preventDefault();

      if (customSizeSelected) {
        const confirmed = await askCustomSizeConfirm();
        if (!confirmed) return;
        setConsent(true);
      }

      await addToCartAjax();
    };

    form.addEventListener('submit', handleSubmit);
  })();

  // ─── Gallery image preload ─────────────────────────────────────────────────
  (() => {
    const runGalleryPreload = () => {
      if (typeof window.luvoraPreloadProductGallery === 'function') {
        window.luvoraPreloadProductGallery();
      }
    };
    runGalleryPreload();
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', runGalleryPreload);
    }
  })();

  // ─── Main image swap ───────────────────────────────────────────────────────
  // Keeps the current picture on screen, dimmed, until the next one has loaded
  // and decoded, so a slow connection never shows an empty frame. A newer swap
  // cancels an older one still loading on the same <img>, and its onApply never
  // runs. onApply runs in the same frame the new picture lands, for UI that
  // must not change ahead of it. Also used by the fullscreen viewer.
  //
  // With `fade` (a metal switch), the loaded picture crossfades in over 120 ms
  // like the product card swatches: a copy of the old one sits on top and both
  // move on the same curve, blended with plus-lighter so they always sum to one.
  (() => {
    const pending = new WeakMap();
    const fades = new WeakMap();
    const FADE_MS = 120;
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const ease = (p) => (p < 0.5 ? 2 * p * p : 1 - (-2 * p + 2) ** 2 / 2);

    // Ends a running crossfade at once, on whatever the <img> holds by then.
    const stopFade = (img) => {
      const fade = fades.get(img);
      if (!fade) return;
      fades.delete(img);
      cancelAnimationFrame(fade.frame);
      fade.layer.remove();
      img.style.transition = '';
      img.style.opacity = '';
    };

    const crossfade = (img, apply) => {
      const from = parseFloat(getComputedStyle(img).opacity) || 1;
      const layer = img.cloneNode(false);
      ['loading', 'fetchpriority'].forEach((a) => layer.removeAttribute(a));
      layer.alt = '';
      layer.setAttribute('aria-hidden', 'true');
      layer.classList.add('product-main-fade-layer');
      layer.style.transition = 'none';
      layer.style.opacity = '0';
      img.after(layer);

      const fade = { layer, frame: 0 };
      fades.set(img, fade);
      const live = () => fades.get(img) === fade;
      const decoded = (el) => el.decode().catch(() => {});

      // The copy and the new picture are both decoded before either shows, so
      // neither frame of the fade can paint an empty layer.
      decoded(layer)
        .then(() => {
          if (!live()) return null;
          layer.style.opacity = String(from);
          img.style.transition = 'none';
          apply({ hidden: true });
          return decoded(img);
        })
        .then(() => {
          if (!live()) return;
          const start = performance.now();
          const step = (now) => {
            if (!live()) return;
            const e = ease(Math.min((now - start) / FADE_MS, 1));
            layer.style.opacity = String(from * (1 - e));
            img.style.opacity = String(e);
            if (e < 1) fade.frame = requestAnimationFrame(step);
            else stopFade(img);
          };
          fade.frame = requestAnimationFrame(step);
        });
    };

    const sameImageUrl = (a, b) => {
      if (!a || !b) return false;
      if (a === b) return true;
      try {
        const ua = new URL(a, 'https://example.com');
        const ub = new URL(b, 'https://example.com');
        if (ua.pathname !== ub.pathname) return false;
        const va = ua.searchParams.get('v');
        const vb = ub.searchParams.get('v');
        return va != null || vb != null ? va === vb : true;
      } catch {
        return false;
      }
    };

    window.luvoraSwapMainImage = (img, { src, srcset = '', sizes = '', alt = null, onApply = null, fade = false }) => {
      if (!img || !src) return;
      pending.delete(img);
      stopFade(img);

      if (sameImageUrl(img.currentSrc || img.src, src)) {
        img.style.opacity = '';
        if (onApply) onApply();
        return;
      }

      const apply = ({ hidden = false } = {}) => {
        if (srcset) {
          img.sizes = sizes;
          img.srcset = srcset;
        } else {
          img.removeAttribute('srcset');
          img.removeAttribute('sizes');
        }
        img.src = src;
        if (alt != null) img.alt = alt;
        img.style.opacity = hidden ? '0' : '';
        if (onApply) onApply();
      };

      // Same srcset + sizes as the real <img>, so it loads the width that shows.
      const loader = new Image();
      if (srcset) {
        loader.sizes = sizes;
        loader.srcset = srcset;
      }
      loader.src = src;
      pending.set(img, loader);

      const finish = () => {
        if (pending.get(img) !== loader) return;
        pending.delete(img);
        if (fade && !reduceMotion.matches && img.parentElement?.hasAttribute('data-product-main-fade')) {
          crossfade(img, apply);
        } else {
          apply();
        }
      };

      if (loader.complete && loader.naturalWidth) {
        finish();
        return;
      }
      img.style.opacity = '0.5';
      if (typeof loader.decode === 'function') {
        loader.decode().then(finish, finish);
      } else {
        loader.onload = finish;
        loader.onerror = finish;
      }
    };
  })();

  // ─── Swipe ─────────────────────────────────────────────────────────────────
  // Horizontal swipe on `el` calls onSwipe(1) for next (finger moving left) or
  // onSwipe(-1) for previous. Vertical drags are left alone so the page still
  // scrolls, and the tap that ends a swipe does not also count as a click.
  (() => {
    window.luvoraOnSwipe = (el, onSwipe) => {
      if (!el) return;
      let startX = 0;
      let startY = 0;
      let tracking = false;
      let suppressClickUntil = 0;

      el.addEventListener(
        'touchstart',
        (event) => {
          tracking = event.touches.length === 1;
          if (!tracking) return;
          startX = event.touches[0].clientX;
          startY = event.touches[0].clientY;
        },
        { passive: true },
      );

      el.addEventListener(
        'touchend',
        (event) => {
          if (!tracking) return;
          tracking = false;
          const touch = event.changedTouches[0];
          const dx = touch.clientX - startX;
          const dy = touch.clientY - startY;
          if (Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy) * 1.5) return;
          suppressClickUntil = Date.now() + 400;
          onSwipe(dx < 0 ? 1 : -1);
        },
        { passive: true },
      );

      el.addEventListener('touchcancel', () => {
        tracking = false;
      });

      el.addEventListener(
        'click',
        (event) => {
          if (Date.now() > suppressClickUntil) return;
          event.preventDefault();
          event.stopPropagation();
        },
        true,
      );
    };
  })();

  // ─── Gallery image switcher ────────────────────────────────────────────────
  (() => {
    const mainContainer = document.querySelector('[data-product-main-image]');
    const thumbs = document.querySelectorAll('[data-product-thumb]');
    if (!mainContainer || !thumbs.length) return;
    const prevBtn = document.querySelector('[data-product-main-nav-prev]');
    const nextBtn = document.querySelector('[data-product-main-nav-next]');
    const thumbRail = document.querySelector('[data-product-thumb-rail]');

    const mainImg = mainContainer.querySelector('img');
    if (!mainImg) return;

    const isThumbVisible = (thumb) => {
      const item = thumb.closest('[data-product-thumb-item]');
      if (!item) return true;
      return !item.hidden && !item.classList.contains('hidden');
    };

    const getVisibleThumbs = () => Array.from(thumbs).filter(isThumbVisible);

    const thumbsForMetal = (metal) =>
      Array.from(thumbs).filter((t) => (t.dataset.metal || '') === metal);

    const normalizeAngle = (value) => {
      if (value == null) return '';
      const raw = String(value).trim().toLowerCase().replace(/^[_-]+/, '');
      if (!raw) return '';
      const digits = raw.match(/(\d+)/);
      if (digits) return String(parseInt(digits[1], 10));
      return raw;
    };

    const rememberAngleFromThumb = (thumb) => {
      if (!thumb) return;
      const metal = thumb.dataset.metal || '';
      const siblings = metal ? thumbsForMetal(metal) : getVisibleThumbs();
      const index = siblings.indexOf(thumb);
      window.luvoraGalleryAngleKey = normalizeAngle(thumb.dataset.angle || '');
      window.luvoraGalleryAngleIndex = index >= 0 ? index : 0;
    };

    const updateGalleryChrome = () => {
      const visible = getVisibleThumbs();
      const show = visible.length > 1;
      if (thumbRail) thumbRail.hidden = !show;
      if (prevBtn) prevBtn.hidden = !show;
      if (nextBtn) nextBtn.hidden = !show;
    };

    // With onApply (a metal switch), the rail keeps its current state, dimmed
    // like the main image, until the new main image lands; then onApply and the
    // active thumb update together. A cached image lands before the dim paints.
    const setRailDimmed = (dimmed) => {
      if (thumbRail) thumbRail.style.opacity = dimmed ? '0.5' : '';
    };

    const setFromThumb = (thumb, { onApply = null } = {}) => {
      const src = thumb.dataset.src;
      if (!src) return;

      const markActive = () => {
        thumbs.forEach((t) => t.classList.remove('product-thumb--active'));
        thumb.classList.add('product-thumb--active');
        revealThumb(thumb);
        preloadNext(thumb);
      };

      rememberAngleFromThumb(thumb);
      setRailDimmed(Boolean(onApply));
      if (!onApply) markActive();

      window.luvoraSwapMainImage(mainImg, {
        src,
        srcset: thumb.dataset.srcset || '',
        sizes: thumb.dataset.sizes || '',
        fade: Boolean(onApply),
        onApply: onApply
          ? () => {
              onApply();
              markActive();
              setRailDimmed(false);
            }
          : null,
      });
    };

    // Centre the active thumb in the rail when it overflows: sideways under the
    // image, vertically in the xl column. Scrolls the rail only, never the page.
    const revealThumb = (thumb) => {
      if (!thumbRail || thumbRail.hidden) return;
      const rail = thumbRail.getBoundingClientRect();
      const box = (thumb.closest('[data-product-thumb-item]') || thumb).getBoundingClientRect();
      // Clamp to the real scroll range: Safari animates a smooth scroll toward an
      // out-of-range target, then snaps back, so near the end it jitters.
      const clamp = (value, max) => Math.round(Math.min(Math.max(value, 0), Math.max(max, 0)));
      const left = clamp(
        thumbRail.scrollLeft + box.left + box.width / 2 - (rail.left + rail.width / 2),
        thumbRail.scrollWidth - thumbRail.clientWidth
      );
      const top = clamp(
        thumbRail.scrollTop + box.top + box.height / 2 - (rail.top + rail.height / 2),
        thumbRail.scrollHeight - thumbRail.clientHeight
      );
      if (Math.abs(left - thumbRail.scrollLeft) < 1 && Math.abs(top - thumbRail.scrollTop) < 1) return;
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      thumbRail.scrollTo({ left, top, behavior: reduceMotion ? 'auto' : 'smooth' });
    };

    // Fetch the image "next" would show now, ahead of the background preload.
    const preloadNext = (thumb) => {
      if (typeof window.luvoraPreloadImageUrls !== 'function') return;
      const visible = getVisibleThumbs();
      const index = visible.indexOf(thumb);
      if (index < 0 || visible.length < 2) return;
      const next = visible[(index + 1) % visible.length];
      window.luvoraPreloadImageUrls([window.luvoraThumbImageEntry(next)], { urgent: true });
    };

    const getActiveIndex = () => {
      const visible = getVisibleThumbs();
      const activeThumb = visible.find((thumb) => thumb.classList.contains('product-thumb--active'));
      const index = activeThumb ? visible.indexOf(activeThumb) : 0;
      return index >= 0 ? index : 0;
    };

    const goToOffset = (delta) => {
      const visible = getVisibleThumbs();
      if (!visible.length) return;
      const nextIndex = (getActiveIndex() + delta + visible.length) % visible.length;
      const targetThumb = visible[nextIndex];
      if (!targetThumb) return;
      setFromThumb(targetThumb);
    };

    thumbs.forEach((thumb) => {
      thumb.addEventListener('mouseenter', () => {
        if (typeof window.luvoraPreloadImageUrls === 'function') {
          window.luvoraPreloadImageUrls([window.luvoraThumbImageEntry(thumb)]);
        }
      });

      thumb.addEventListener('click', () => {
        setFromThumb(thumb);
      });
    });

    if (prevBtn) {
      prevBtn.addEventListener('click', (event) => {
        event.preventDefault();
        goToOffset(-1);
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', (event) => {
        event.preventDefault();
        goToOffset(1);
      });
    }

    // The whole shell, so a swipe that starts on an edge tap strip still pages.
    window.luvoraOnSwipe(mainContainer.closest('.product-main-image-shell') || mainContainer, goToOffset);

    // Arrow keys page the main image; the lightbox has its own handler.
    document.addEventListener('keydown', (event) => {
      if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
      if (event.defaultPrevented || event.altKey || event.ctrlKey || event.metaKey || event.shiftKey) return;
      if (document.querySelector('dialog[open]')) return;
      const target = event.target;
      if (target instanceof Element && target.closest('input, select, textarea, [contenteditable], [role="radio"], [role="slider"], [role="tab"]')) return;
      if (getVisibleThumbs().length < 2) return;
      event.preventDefault();
      goToOffset(event.key === 'ArrowLeft' ? -1 : 1);
    });

    const activeOnLoad = document.querySelector('[data-product-thumb].product-thumb--active');
    if (activeOnLoad) rememberAngleFromThumb(activeOnLoad);
    else if (getVisibleThumbs()[0]) rememberAngleFromThumb(getVisibleThumbs()[0]);

    window.luvoraNormalizeGalleryAngle = normalizeAngle;
    window.luvoraSetProductGalleryThumb = setFromThumb;
    window.luvoraUpdateProductGalleryChrome = updateGalleryChrome;
    window.luvoraRememberGalleryAngle = rememberAngleFromThumb;
    updateGalleryChrome();
  })();

  // ─── Fullscreen gallery lightbox ───────────────────────────────────────────
  (() => {
    const dialog = document.querySelector('[data-product-lightbox]');
    const openBtn = document.querySelector('[data-product-lightbox-open]');
    const jsonEl = document.getElementById('ProductGalleryImagesJson');
    if (!dialog || !openBtn || !jsonEl) return;

    let allImages = [];
    try {
      allImages = JSON.parse(jsonEl.textContent || '[]');
    } catch {
      allImages = [];
    }
    if (!allImages.length) return;

    const imgEl = dialog.querySelector('[data-product-lightbox-img]');
    const counterEl = dialog.querySelector('[data-product-lightbox-counter]');
    const closeBtn = dialog.querySelector('[data-product-lightbox-close]');
    const prevBtn = dialog.querySelector('[data-product-lightbox-prev]');
    const nextBtn = dialog.querySelector('[data-product-lightbox-next]');
    if (!imgEl) return;

    let index = 0;
    let scrollLockY = 0;
    const counterTemplate = counterEl ? counterEl.dataset.counterTemplate || '' : '';

    // ─── Pinch zoom ───
    // Pinch zooms around the fingers (up to 4x), one finger pans while zoomed,
    // double tap in the middle toggles 2.5x. Page zoom stays blocked by the
    // touchmove handler below, so the controls never zoom with the photo.
    // At 1x, like the product image: a tap on either edge strip pages, a single
    // tap in the middle closes (after the double-tap window), sideways swipes
    // page, and a drag up or down closes (see swipe to close below).
    // Matches the CSS scale on .product-lightbox__img (1 for necklaces, set on the dialog).
    const BASE_SCALE = parseFloat(getComputedStyle(dialog).getPropertyValue('--lb-base-scale')) || 1.3;
    const MAX_ZOOM = 4;
    const STEP_ZOOM = 2.5; // double tap, and a mouse click (see mouse zoom below)
    let zoom = 1;
    let panX = 0;
    let panY = 0;
    let gesture = null;
    let lastTap = { time: 0, x: 0, y: 0 };
    let closeTimer = null;
    const EDGE_STRIP = 0.18; // matches the product image's tap strips
    const DOUBLE_TAP_MS = 300;

    // Untransformed centre of the image: the transform scales around it.
    const imageCentre = () => {
      const r = imgEl.getBoundingClientRect();
      return { x: r.left + r.width / 2 - panX, y: r.top + r.height / 2 - panY };
    };

    // Let a zoomed image pan until its edge reaches the middle of the screen, so
    // a detail on the edge of the photo can still be centred.
    const clampPan = (t, centre, size, viewport) => {
      const mid = viewport / 2 - centre;
      return Math.min(mid + size / 2, Math.max(mid - size / 2, t));
    };

    const setZoom = (nextZoom, nextX = 0, nextY = 0) => {
      const c = imageCentre();
      zoom = Math.min(MAX_ZOOM, Math.max(1, nextZoom));
      if (zoom === 1) {
        panX = 0;
        panY = 0;
      } else {
        const scale = BASE_SCALE * zoom;
        panX = clampPan(nextX, c.x, imgEl.offsetWidth * scale, window.innerWidth);
        panY = clampPan(nextY, c.y, imgEl.offsetHeight * scale, window.innerHeight);
      }
      imgEl.style.setProperty('--lb-zoom', String(zoom));
      imgEl.style.setProperty('--lb-pan-x', `${panX}px`);
      imgEl.style.setProperty('--lb-pan-y', `${panY}px`);
      dialog.classList.toggle('is-zoomed', zoom > 1);
    };

    // Swipe to close: at 1x a vertical drag carries the photo with the finger,
    // shrinks and fades it, and lets the page show through. Released far enough out
    // it closes; released near the start, or while heading back, it settles.
    const DISMISS_DISTANCE = 80;
    const DISMISS_FLICK = 0.5; // px per ms
    let dragAxis = null;

    const setDismissDrag = (dy) => {
      const d = Math.min(1, Math.abs(dy) / (window.innerHeight * 0.4));
      imgEl.style.setProperty('--lb-drag-y', `${dy}px`);
      imgEl.style.setProperty('--lb-drag-scale', String(1 - 0.2 * d));
      imgEl.style.setProperty('--lb-drag-opacity', String(1 - 0.8 * d));
      dialog.style.setProperty('--lb-fill', `${(1 - d) * 100}%`);
    };

    const resetDismissDrag = () => {
      setDismissDrag(0);
      dialog.classList.remove('is-dismissing');
    };

    const dismiss = (dy) => {
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        close();
        return;
      }
      imgEl.style.setProperty('--lb-drag-y', `${Math.sign(dy) * window.innerHeight}px`);
      imgEl.style.setProperty('--lb-drag-opacity', '0');
      dialog.style.setProperty('--lb-fill', '0%');
      setTimeout(() => close(), 200);
    };

    // Pan that keeps the point under `focus` still while zooming fromZoom → toZoom.
    const panAround = (focus, fromZoom, toZoom, fromPan, centre) =>
      focus - centre - (toZoom / fromZoom) * (focus - centre - fromPan);

    const touchPoint = (touches) => {
      const a = touches[0];
      const b = touches[1] || a;
      return {
        x: (a.clientX + b.clientX) / 2,
        y: (a.clientY + b.clientY) / 2,
        dist: Math.hypot(a.clientX - b.clientX, a.clientY - b.clientY),
      };
    };

    const startGesture = (touches) => {
      // A second finger landing mid swipe to close turns it into a pinch.
      if (gesture && gesture.axis === 'y') resetDismissDrag();
      const p = touchPoint(touches);
      const kind = touches.length >= 2 ? 'pinch' : zoom > 1 ? 'pan' : null;
      // Tracked at 1x too (kind null), so a swipe counts as moved, not a tap.
      gesture = { kind, start: p, zoom, panX, panY, centre: imageCentre(), moved: false };
      dialog.classList.toggle('is-pinching', Boolean(kind));
    };

    dialog.addEventListener('gesturestart', (event) => event.preventDefault());

    dialog.addEventListener(
      'touchstart',
      (event) => {
        // Any new touch cancels a pending middle-tap close: a double tap or swipe.
        if (closeTimer) {
          clearTimeout(closeTimer);
          closeTimer = null;
        }
        if (event.target instanceof Element && event.target.closest('button')) return;
        startGesture(event.touches);
      },
      { passive: true },
    );

    dialog.addEventListener(
      'touchmove',
      (event) => {
        if (!gesture) return;
        const p = touchPoint(event.touches);
        const g = gesture;
        if (Math.hypot(p.x - g.start.x, p.y - g.start.y) > 6) g.moved = true;
        if (g.kind === 'pinch' && event.touches.length >= 2 && g.start.dist > 0) {
          g.moved = true;
          const next = Math.min(MAX_ZOOM, Math.max(1, g.zoom * (p.dist / g.start.dist)));
          setZoom(
            next,
            panAround(g.start.x, g.zoom, next, g.panX, g.centre.x) + (p.x - g.start.x),
            panAround(g.start.y, g.zoom, next, g.panY, g.centre.y) + (p.y - g.start.y),
          );
        } else if (g.kind === 'pan') {
          setZoom(zoom, g.panX + (p.x - g.start.x), g.panY + (p.y - g.start.y));
        } else if (g.kind === null && !g.afterPinch && event.touches.length === 1) {
          const dx = p.x - g.start.x;
          const dy = p.y - g.start.y;
          if (!g.axis && Math.hypot(dx, dy) > 10) {
            g.axis = Math.abs(dy) > Math.abs(dx) ? 'y' : 'x';
            if (g.axis === 'y') dialog.classList.add('is-pinching', 'is-dismissing');
          }
          if (g.axis === 'y') {
            const now = event.timeStamp;
            if (g.lastT) g.vy = 0.7 * ((dy - g.lastDy) / Math.max(1, now - g.lastT)) + 0.3 * (g.vy || 0);
            g.lastDy = dy;
            g.lastT = now;
            setDismissDrag(dy);
          }
        }
      },
      { passive: true },
    );

    dialog.addEventListener('touchend', (event) => {
      const moved = gesture ? gesture.moved : false;
      // Lifting one finger of a pinch carries on as a pan with the other. It is
      // never a tap: lifting that last finger would otherwise close the lightbox
      // after a pinch out at 1x.
      if (event.touches.length) {
        startGesture(event.touches);
        gesture.moved = true;
        gesture.afterPinch = true;
        return;
      }
      const g = gesture;
      gesture = null;
      dialog.classList.remove('is-pinching');
      if (zoom < 1.05) setZoom(1);

      const touch = event.changedTouches[0];
      dragAxis = g ? g.axis : null;
      if (dragAxis === 'y') {
        const dy = g.lastDy || 0;
        const vy = g.vy || 0;
        const outward = Math.sign(vy) === Math.sign(dy);
        const headingBack = !outward && Math.abs(vy) > 0.2;
        const flick = outward && Math.abs(vy) > DISMISS_FLICK && Math.abs(dy) > 30;
        if ((Math.abs(dy) >= DISMISS_DISTANCE && !headingBack) || flick) dismiss(dy);
        else resetDismissDrag();
        return;
      }
      if (!touch || moved || event.changedTouches.length > 1) return;
      if (event.target instanceof Element && event.target.closest('button')) return;
      const now = Date.now();
      const isDoubleTap =
        now - lastTap.time < DOUBLE_TAP_MS && Math.hypot(touch.clientX - lastTap.x, touch.clientY - lastTap.y) < 30;
      lastTap = isDoubleTap ? { time: 0, x: 0, y: 0 } : { time: now, x: touch.clientX, y: touch.clientY };

      if (!isDoubleTap) {
        if (zoom > 1) return;
        const edge = window.innerWidth * EDGE_STRIP;
        const step = touch.clientX < edge ? -1 : touch.clientX > window.innerWidth - edge ? 1 : 0;
        if (step) {
          // Edge taps never pair into a double tap, so quick taps keep paging.
          lastTap = { time: 0, x: 0, y: 0 };
          if (getVisibleImages().length > 1) renderAt(index + step);
          return;
        }
        closeTimer = setTimeout(() => {
          closeTimer = null;
          if (dialog.open) close();
        }, DOUBLE_TAP_MS);
        return;
      }

      toggleStepZoom(touch.clientX, touch.clientY);
    });

    dialog.addEventListener('touchcancel', () => {
      gesture = null;
      dialog.classList.remove('is-pinching');
      resetDismissDrag();
    });

    // One step in around the point, or back out to 1x.
    const toggleStepZoom = (x, y) => {
      if (zoom > 1) {
        setZoom(1);
      } else {
        const c = imageCentre();
        setZoom(STEP_ZOOM, panAround(x, 1, STEP_ZOOM, 0, c.x), panAround(y, 1, STEP_ZOOM, 0, c.y));
      }
    };

    // ─── Mouse zoom ───
    // A click on the photo zooms one step around the pointer, a drag pans while
    // zoomed, and a click without a drag zooms back out. Touch keeps the
    // gestures above.
    let mouseDrag = null;

    const endMouseDrag = () => {
      mouseDrag = null;
      dialog.classList.remove('is-dragging');
    };

    imgEl.addEventListener('pointerdown', (event) => {
      if (event.pointerType !== 'mouse' || event.button !== 0) return;
      mouseDrag = { x: event.clientX, y: event.clientY, panX, panY, moved: false };
      imgEl.setPointerCapture(event.pointerId);
      if (zoom > 1) dialog.classList.add('is-dragging');
    });

    imgEl.addEventListener('pointermove', (event) => {
      const d = mouseDrag;
      if (!d) return;
      const dx = event.clientX - d.x;
      const dy = event.clientY - d.y;
      if (!d.moved && Math.hypot(dx, dy) < 4) return;
      d.moved = true;
      if (zoom > 1) setZoom(zoom, d.panX + dx, d.panY + dy);
    });

    imgEl.addEventListener('pointerup', (event) => {
      const d = mouseDrag;
      endMouseDrag();
      if (d && !d.moved) toggleStepZoom(event.clientX, event.clientY);
    });

    // Also covers a cancel, and Escape closing the viewer mid drag.
    imgEl.addEventListener('lostpointercapture', endMouseDrag);

    const isMultiAngle = () =>
      window.luvoraMultiAngleGallery === true ||
      document.querySelector('[data-product-gallery]')?.dataset.multiAngleGallery === 'true';

    const showUnmatchedImages = () =>
      document.querySelector('[data-product-gallery]')?.dataset.galleryShowUnmatched === 'true';

    const getVisibleImages = () => {
      if (!isMultiAngle()) return allImages;
      const activeThumb = document.querySelector('[data-product-thumb].product-thumb--active');
      const showUnmatched = showUnmatchedImages();
      let metal = activeThumb?.dataset.metal || '';
      if (!metal && showUnmatched) {
        // An image with no metal shows for every metal, so take the metal the rail shows.
        const shown = document.querySelector(
          '[data-product-thumb-item]:not([hidden]) [data-product-thumb][data-metal]:not([data-metal=""])'
        );
        metal = shown?.dataset.metal || '';
      }
      if (!metal) return allImages;
      const filtered = allImages.filter(
        (item) => item.metal === metal || (showUnmatched && !item.metal)
      );
      return filtered.length ? filtered : allImages;
    };

    const updateLightboxNav = (images) => {
      const show = images.length > 1;
      if (prevBtn) prevBtn.hidden = !show;
      if (nextBtn) nextBtn.hidden = !show;
      if (counterEl) counterEl.hidden = !show;
    };

    const lockPageScroll = () => {
      scrollLockY = window.scrollY || window.pageYOffset || 0;
      document.documentElement.classList.add('product-lightbox-open');
      document.body.style.position = 'fixed';
      document.body.style.top = '-' + scrollLockY + 'px';
      document.body.style.left = '0';
      document.body.style.right = '0';
      document.body.style.width = '100%';
      document.body.style.overflow = 'hidden';
    };

    const unlockPageScroll = () => {
      document.documentElement.classList.remove('product-lightbox-open');
      document.body.style.removeProperty('position');
      document.body.style.removeProperty('top');
      document.body.style.removeProperty('left');
      document.body.style.removeProperty('right');
      document.body.style.removeProperty('width');
      document.body.style.removeProperty('overflow');
      window.scrollTo(0, scrollLockY);
    };

    const urlsMatch = (a, b) => {
      if (!a || !b) return a === b;
      if (a === b) return true;
      try {
        const ua = new URL(a, 'https://example.com');
        const ub = new URL(b, 'https://example.com');
        if (ua.pathname !== ub.pathname) return false;
        const va = ua.searchParams.get('v');
        const vb = ub.searchParams.get('v');
        if (va != null || vb != null) return va === vb;
        return true;
      } catch {
        return false;
      }
    };

    const getCurrentMainIndex = (images) => {
      const activeThumb = document.querySelector('[data-product-thumb].product-thumb--active');
      if (activeThumb && activeThumb.dataset.imageId !== undefined) {
        const thumbIndex = images.findIndex((item) => String(item.id) === String(activeThumb.dataset.imageId));
        if (thumbIndex >= 0) return thumbIndex;
      }

      const mainImg = document.querySelector('[data-product-main-image] img');
      if (mainImg && mainImg.src) {
        const srcIndex = images.findIndex((item) => urlsMatch(item.src, mainImg.src));
        if (srcIndex >= 0) return srcIndex;
      }

      return 0;
    };

    const updateCounter = (images) => {
      if (!counterEl || images.length < 2) return;
      const current = String(index + 1);
      const total = String(images.length);
      if (counterTemplate.indexOf('__CURRENT__') !== -1) {
        counterEl.textContent = counterTemplate.replace('__CURRENT__', current).replace('__TOTAL__', total);
      } else {
        counterEl.textContent = current + ' / ' + total;
      }
    };

    const renderAt = (nextIndex) => {
      const images = getVisibleImages();
      if (!images.length) return;
      setZoom(1);
      updateLightboxNav(images);
      index = (nextIndex + images.length) % images.length;
      const item = images[index];
      if (!item) return;

      window.luvoraSwapMainImage(imgEl, {
        src: item.src,
        srcset: item.srcset || '',
        sizes: item.srcset ? item.sizes || '100vw' : '',
        alt: item.alt || '',
      });
      updateCounter(images);
      if (images.length > 1 && typeof window.luvoraPreloadImageUrls === 'function') {
        window.luvoraPreloadImageUrls([images[(index + 1) % images.length]], { urgent: true });
      }
    };

    // The rest of the metal on screen, onward from the open photo, at idle time.
    const preloadRest = (images) => {
      if (images.length < 3 || typeof window.luvoraPreloadImageUrls !== 'function') return;
      window.luvoraPreloadImageUrls([...images.slice(index + 2), ...images.slice(0, index)]);
    };

    // Escape only hands focus (and its ring) back to the image when the viewer
    // was opened from the keyboard; a mouse user pressing Escape gets no ring.
    let openedByKeyboard = false;

    const open = (event) => {
      openedByKeyboard = Boolean(event && event.detail === 0);
      const images = getVisibleImages();
      renderAt(getCurrentMainIndex(images));
      preloadRest(images);
      lockPageScroll();
      if (typeof dialog.showModal === 'function') {
        dialog.showModal();
      }
      // Keyboard opens (click detail 0) focus the close button. Pointer opens
      // focus the dialog itself, or Safari rings the button in focus-visible.
      if (openedByKeyboard) closeBtn.focus();
      else dialog.focus();
    };

    // Keyboard closes hand focus back to the image, ring and all. Pointer closes
    // drop focus instead: the dialog's own focus restore would ring the image.
    const close = ({ restoreFocus = false } = {}) => {
      if (dialog.open) {
        dialog.close();
      }
      resetDismissDrag();
      unlockPageScroll();
      if (restoreFocus) {
        openBtn.focus({ preventScroll: true });
      } else if (document.activeElement instanceof HTMLElement) {
        document.activeElement.blur();
      }
    };

    openBtn.addEventListener('click', open);

    // The photo the viewer opens on, fetched last of all: after the page has
    // loaded, so its idle fetch queues behind the gallery's. Same srcset and
    // sizes as the viewer's <img>, so the open finds that width in the cache.
    const preloadOpening = () => {
      if (typeof window.luvoraPreloadImageUrls !== 'function') return;
      const images = getVisibleImages();
      const item = images[getCurrentMainIndex(images)];
      if (item) window.luvoraPreloadImageUrls([item]);
    };
    if (document.readyState === 'complete') preloadOpening();
    else window.addEventListener('load', preloadOpening, { once: true });

    if (closeBtn) {
      closeBtn.addEventListener('click', (event) => close({ restoreFocus: event.detail === 0 }));
    }

    dialog.addEventListener('click', (event) => {
      if (event.target === dialog) {
        close();
      }
    });

    dialog.addEventListener('wheel', (event) => {
      event.preventDefault();
    }, { passive: false });

    dialog.addEventListener('touchmove', (event) => {
      event.preventDefault();
    }, { passive: false });

    dialog.addEventListener('cancel', (event) => {
      event.preventDefault();
      close({ restoreFocus: openedByKeyboard });
    });

    if (prevBtn) {
      prevBtn.addEventListener('click', () => {
        renderAt(index - 1);
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', () => {
        renderAt(index + 1);
      });
    }

    window.luvoraOnSwipe(dialog, (delta) => {
      // A drag that began as swipe to close never pages, wherever it ends up.
      if (zoom > 1 || dragAxis === 'y') return;
      if (getVisibleImages().length > 1) renderAt(index + delta);
    });

    dialog.addEventListener('keydown', (event) => {
      if (!dialog.open) return;
      if (event.key === 'ArrowLeft' && prevBtn) {
        event.preventDefault();
        renderAt(index - 1);
      }
      if (event.key === 'ArrowRight' && nextBtn) {
        event.preventDefault();
        renderAt(index + 1);
      }
    });

    document.querySelectorAll('[data-product-thumb]').forEach((thumb) => {
      thumb.addEventListener('click', () => {
        if (!dialog.open) return;
        const images = getVisibleImages();
        const thumbIndex = images.findIndex((item) => String(item.id) === String(thumb.dataset.imageId));
        if (thumbIndex >= 0) {
          renderAt(thumbIndex);
        }
      });
    });

    const mainImg = document.querySelector('[data-product-main-image] img');
    if (mainImg) {
      new MutationObserver(() => {
        if (!dialog.open) return;
        const images = getVisibleImages();
        const nextIndex = getCurrentMainIndex(images);
        if (nextIndex !== index) {
          renderAt(nextIndex);
        }
      }).observe(mainImg, { attributes: true, attributeFilter: ['src'] });
    }
  })();

  // ─── Metall option → image sync ────────────────────────────────────────────
  // Reads the selection from the options app's `product-options:change` event,
  // which fires on initial render and on every change.
  (() => {
    const DEFAULT_IMAGE_METAL = 'yellow_gold';
    const METALL_GROUP = 'Metall';
    let lastSyncedImageMetal = null;

    const urlsMatchForGallery = (a, b) => {
      if (!a || !b) return a === b;
      if (a === b) return true;
      try {
        const ua = new URL(a, 'https://example.com');
        const ub = new URL(b, 'https://example.com');
        if (ua.pathname !== ub.pathname) return false;
        const va = ua.searchParams.get('v');
        const vb = ub.searchParams.get('v');
        if (va != null || vb != null) return va === vb;
        return true;
      } catch {
        return false;
      }
    };

    const setActiveThumb = (imageId, src) => {
      document.querySelectorAll('[data-product-thumb]').forEach((t) => {
        let active = false;
        if (imageId != null && imageId !== '' && t.dataset.imageId !== undefined) {
          active = String(t.dataset.imageId) === String(imageId);
        }
        if (!active && src) {
          active = urlsMatchForGallery(t.dataset.src || '', src);
        }
        t.classList.toggle('product-thumb--active', active);
      });
    };

    const metalSlugFromLabel = (label) => {
      const normalized = String(label).toLowerCase().replace(/\s+/g, ' ').trim();
      if (!normalized) return null;

      if (
        normalized.includes('rosegull') ||
        normalized.includes('rose gold') ||
        normalized.includes('rose_gold') ||
        normalized.includes('rose-gold')
      ) {
        return 'rose_gold';
      }

      if (normalized.includes('platina') || normalized.includes('platinum')) {
        return 'platinum';
      }

      if (
        normalized.includes('hvitt gull') ||
        normalized.includes('white gold') ||
        normalized.includes('white_gold') ||
        normalized.includes('white-gold') ||
        normalized.includes('hvittgull')
      ) {
        return 'white_gold';
      }

      if (
        normalized.includes('gult gull') ||
        normalized.includes('yellow gold') ||
        normalized.includes('yellow_gold') ||
        normalized.includes('yellow-gold') ||
        normalized.includes('gultgull')
      ) {
        return 'yellow_gold';
      }

      return null;
    };

    const imageMetalForSlug = (slug) => {
      if (slug === 'platinum') return 'white_gold';
      return slug;
    };

    const getMetalImageList = (slug) => {
      const map = window.luvoraProductImages || {};
      const imageMetal = imageMetalForSlug(slug);
      let list = map[imageMetal];
      if (!list && slug === 'platinum') list = map.white_gold;
      if (!list) return [];
      return Array.isArray(list) ? list : [list];
    };

    const isMultiAngle = () =>
      window.luvoraMultiAngleGallery === true ||
      document.querySelector('[data-product-gallery]')?.dataset.multiAngleGallery === 'true';

    const showUnmatchedImages = () =>
      document.querySelector('[data-product-gallery]')?.dataset.galleryShowUnmatched === 'true';

    const applyEntryToMain = (entry, { onApply = null } = {}) => {
      if (!entry) return;
      const imageId = typeof entry === 'string' ? null : entry.id;
      const src = typeof entry === 'string' ? entry : entry.src;
      const srcset = typeof entry === 'string' ? '' : entry.srcset || '';
      const sizes = typeof entry === 'string' ? '' : entry.sizes || '';
      if (!src) return;

      const mainContainer = document.querySelector('[data-product-main-image]');
      if (!mainContainer) return;
      const img = mainContainer.querySelector('img');
      if (!img) return;

      window.luvoraSwapMainImage(img, {
        src,
        srcset,
        sizes,
        fade: true,
        onApply: () => {
          if (onApply) onApply();
          setActiveThumb(imageId, src);
        },
      });
    };

    const setThumbItemVisibility = (item, visible) => {
      if (!item) return;
      item.hidden = !visible;
      item.classList.toggle('hidden', !visible);
    };

    const normalizeAngle =
      typeof window.luvoraNormalizeGalleryAngle === 'function'
        ? window.luvoraNormalizeGalleryAngle
        : (value) => {
            if (value == null) return '';
            const raw = String(value).trim().toLowerCase().replace(/^[_-]+/, '');
            if (!raw) return '';
            const digits = raw.match(/(\d+)/);
            if (digits) return String(parseInt(digits[1], 10));
            return raw;
          };

    // Metal whose thumbs the rail shows. Lags the selection while the new main
    // image loads, so the rail never switches ahead of it.
    let shownThumbMetal = null;

    const showThumbsFor = (thumbs, imageMetal) => {
      shownThumbMetal = imageMetal;
      const showUnmatched = showUnmatchedImages();
      thumbs.forEach((t) => {
        const item = t.closest('[data-product-thumb-item]');
        const metal = t.dataset.metal || '';
        setThumbItemVisibility(item, metal === imageMetal || (showUnmatched && !metal));
      });
      if (typeof window.luvoraUpdateProductGalleryChrome === 'function') {
        window.luvoraUpdateProductGalleryChrome();
      }
      if (typeof window.luvoraAdvanceThumbFade === 'function') {
        window.luvoraAdvanceThumbFade();
      }
    };

    const syncMultiAngleGallery = (imageMetal, { forceImage = true } = {}) => {
      const thumbs = Array.from(document.querySelectorAll('[data-product-thumb]'));
      if (!thumbs.length) return;

      if (!forceImage) {
        showThumbsFor(thumbs, shownThumbMetal || imageMetal);
        return;
      }

      const active = thumbs.find((t) => t.classList.contains('product-thumb--active'));
      // An image with no metal shows for every metal, so it stays on screen.
      if (showUnmatchedImages() && active && !active.dataset.metal) {
        showThumbsFor(thumbs, imageMetal);
        return;
      }
      const rememberedKey =
        window.luvoraGalleryAngleKey != null ? normalizeAngle(window.luvoraGalleryAngleKey) : '';
      const activeKey = active ? normalizeAngle(active.dataset.angle || '') : '';
      const currentAngle = rememberedKey || activeKey;

      const wasVisible = thumbs.filter((t) => {
        const item = t.closest('[data-product-thumb-item]');
        if (!item) return true;
        return !item.hidden && !item.classList.contains('hidden');
      });
      const rememberedIndex =
        typeof window.luvoraGalleryAngleIndex === 'number' ? window.luvoraGalleryAngleIndex : -1;
      const activeIndex = active ? wasVisible.indexOf(active) : -1;
      const currentIndex = rememberedIndex >= 0 ? rememberedIndex : activeIndex;

      const visible = thumbs.filter((t) => (t.dataset.metal || '') === imageMetal);

      let target = null;
      if (currentAngle) {
        target =
          visible.find((t) => normalizeAngle(t.dataset.angle || '') === currentAngle) || null;
      }
      if (!target && currentIndex >= 0 && visible.length) {
        target = visible[Math.min(currentIndex, visible.length - 1)] || null;
      }
      if (!target) target = visible[0] || null;
      if (!target) {
        showThumbsFor(thumbs, imageMetal);
        return;
      }

      const onApply = () => showThumbsFor(thumbs, imageMetal);
      if (typeof window.luvoraSetProductGalleryThumb === 'function') {
        window.luvoraSetProductGalleryThumb(target, { onApply });
      } else {
        applyEntryToMain(
          {
            id: target.dataset.imageId,
            src: target.dataset.src,
            srcset: target.dataset.srcset || '',
            sizes: target.dataset.sizes || '',
          },
          { onApply }
        );
        if (typeof window.luvoraRememberGalleryAngle === 'function') {
          window.luvoraRememberGalleryAngle(target);
        }
      }
    };

    const syncLegacyGallery = (slug) => {
      const list = getMetalImageList(slug);
      const entry = list[0];
      if (!entry) return;
      applyEntryToMain(entry);
    };

    const resolveImageMetal = (label) => {
      if (!label) {
        if (isMultiAngle() && lastSyncedImageMetal == null) return DEFAULT_IMAGE_METAL;
        return null;
      }
      const slug = metalSlugFromLabel(label);
      if (!slug) return null;
      return imageMetalForSlug(slug);
    };

    const syncImage = (label) => {
      const imageMetal = resolveImageMetal(label);
      if (!imageMetal) return;

      if (imageMetal === lastSyncedImageMetal) {
        if (isMultiAngle()) {
          syncMultiAngleGallery(imageMetal, { forceImage: false });
        }
        return;
      }

      lastSyncedImageMetal = imageMetal;

      if (isMultiAngle()) {
        syncMultiAngleGallery(imageMetal, { forceImage: true });
        return;
      }

      syncLegacyGallery(imageMetal);
    };

    let syncImageRaf = null;
    const scheduleSyncImage = (label) => {
      if (syncImageRaf) cancelAnimationFrame(syncImageRaf);
      syncImageRaf = requestAnimationFrame(() => {
        syncImageRaf = null;
        syncImage(label);
      });
    };

    const readMetallLabel = (detail) => {
      const selections = (detail && detail.selections) || [];
      const match = selections.find((s) => s && s.groupName === METALL_GROUP);
      return match && match.label ? match.label : null;
    };

    let heardOptionsEvent = false;

    document.addEventListener('product-options:change', (event) => {
      heardOptionsEvent = true;
      scheduleSyncImage(readMetallLabel(event.detail));
    });

    // Products without an options block never fire the event, so seed the
    // multi-angle gallery rather than leave it showing every metal at once.
    // Skipped once the app has spoken — seeding then would flash the default
    // metal before the real selection lands on the next frame.
    const init = () => {
      if (heardOptionsEvent) return;
      if (!isMultiAngle()) return;
      if (lastSyncedImageMetal != null) return;
      lastSyncedImageMetal = DEFAULT_IMAGE_METAL;
      syncMultiAngleGallery(DEFAULT_IMAGE_METAL, { forceImage: true });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();

  // ─── Availability panel ↔ selected variant ─────────────────────────────────
  // The options app owns [data-product-sticky-price]; it writes the running
  // total there itself. Never compute or write that price from the theme.
  (() => {
    const variantInput = document.querySelector('#luvora-product-form input[name="id"]');
    if (!variantInput) return;

    const availabilityRoot = document.querySelector('[data-product-availability]');
    let variantInStockMap = {};
    if (availabilityRoot && availabilityRoot.dataset.variantInStock) {
      try {
        variantInStockMap = JSON.parse(availabilityRoot.dataset.variantInStock);
      } catch (_) {}
    }

    const syncAvailability = (variantId) => {
      if (!availabilityRoot || !variantId) return;
      const inStockPanel = availabilityRoot.querySelector('[data-availability-in-stock]');
      const madeToOrderPanel = availabilityRoot.querySelector('[data-availability-made-to-order]');
      const inStock = variantInStockMap[String(variantId)] === true;
      if (inStockPanel) inStockPanel.classList.toggle('hidden', !inStock);
      if (madeToOrderPanel) madeToOrderPanel.classList.toggle('hidden', inStock);
    };

    variantInput.addEventListener('change', () => {
      syncAvailability(variantInput.value);
    });
    document.addEventListener('shopify:section:load', () => {
      syncAvailability(variantInput.value);
    });
    syncAvailability(variantInput.value);
  })();

  (() => {
    const bar = document.querySelector('[data-product-sticky-bar]');
    const syncBarHeight = () => {
      if (!bar) return;
      document.documentElement.style.setProperty(
        '--luvora-product-sticky-bar-height',
        `${Math.ceil(bar.getBoundingClientRect().height)}px`
      );
    };
    syncBarHeight();
    window.addEventListener('resize', syncBarHeight, { passive: true });
    if (bar && window.ResizeObserver) {
      new ResizeObserver(syncBarHeight).observe(bar);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ring-size-guide"]) return;
  try {
    
  function ringSizeGuideEuFromInnerDiameterMm(diameterMm) {
    return Math.PI * diameterMm;
  }

  /*
    Sizes are whole EU numbers. Within a quarter of a size of a whole number the
    result is that number; in between it is the larger of the two, with a note
    saying so, since a ring that will not pass the knuckle is the worse miss.
  */
  function ringSizeGuideWholeSize(eu) {
    var lower = Math.floor(eu);
    var frac = eu - lower;
    if (frac < 0.25) {
      return { size: lower, between: false };
    }
    if (frac > 0.75) {
      return { size: lower + 1, between: false };
    }
    return { size: lower + 1, between: true };
  }

  // Marks the calculator's result in the size chart; null clears it.
  function ringSizeGuideMarkChartRow(size) {
    document.querySelectorAll('[data-ring-size-row]').forEach(function (row) {
      row.classList.toggle('is-match', size !== null && row.getAttribute('data-ring-size-row') === String(size));
    });
  }

  function ringSizeGuideInitCalculator(root) {
    if (!root || root.getAttribute('data-ring-calc-ready') === '1') {
      return;
    }
    root.setAttribute('data-ring-calc-ready', '1');
    var input = root.querySelector('[data-ring-calc-input]');
    var submit = root.querySelector('[data-ring-calc-submit]');
    var errEl = root.querySelector('[data-ring-calc-error]');
    var outEl = root.querySelector('[data-ring-calc-result]');
    var noteEl = root.querySelector('[data-ring-calc-result-note]');
    if (!input || !submit || !errEl || !outEl || !noteEl) {
      return;
    }
    var msgs = root.querySelector('[data-ring-calc-msgs]');
    function ringSizeGuideMsg(sel, fallback) {
      if (!msgs) {
        return fallback || '';
      }
      var el = msgs.querySelector(sel);
      if (!el) {
        return fallback || '';
      }
      var t = el.textContent;
      if (t) {
        t = t.trim();
      }
      return t || fallback || '';
    }
    var strInvalid = ringSizeGuideMsg('[data-ring-calc-msg-invalid]', '');
    var strEu = ringSizeGuideMsg('[data-ring-calc-msg-eu]', 'EU');
    var strNote = ringSizeGuideMsg('[data-ring-calc-msg-note]', '');
    var strBetween = ringSizeGuideMsg('[data-ring-calc-msg-between]', '');
    var strOutside = ringSizeGuideMsg('[data-ring-calc-msg-outside]', '');
    var sizeMin = parseInt(root.getAttribute('data-size-min'), 10);
    var sizeMax = parseInt(root.getAttribute('data-size-max'), 10);

    function hideError() {
      errEl.textContent = '';
      errEl.classList.add('hidden');
    }

    function showError(msg) {
      errEl.textContent = msg;
      errEl.classList.remove('hidden');
      outEl.textContent = '';
      outEl.classList.add('hidden');
      noteEl.textContent = '';
      noteEl.classList.add('hidden');
      ringSizeGuideMarkChartRow(null);
    }

    function runCalc() {
      hideError();
      var raw = String(input.value || '').trim().replace(',', '.');
      var diameterMm = parseFloat(raw);
      if (raw === '' || Number.isNaN(diameterMm)) {
        showError(strInvalid);
        return;
      }
      if (diameterMm < 10 || diameterMm > 30) {
        showError(strInvalid);
        return;
      }
      var result = ringSizeGuideWholeSize(ringSizeGuideEuFromInnerDiameterMm(diameterMm));
      var notes = [];
      if (result.between) {
        notes.push(
          strBetween.split('%LOWER%').join(String(result.size - 1)).split('%UPPER%').join(String(result.size))
        );
      }
      if (result.size < sizeMin || result.size > sizeMax) {
        notes.push(strOutside);
      }
      notes.push(strNote);
      outEl.textContent = strEu + ' ' + result.size;
      outEl.classList.remove('hidden');
      noteEl.textContent = notes.filter(Boolean).join(' ');
      noteEl.classList.remove('hidden');
      ringSizeGuideMarkChartRow(result.size);
    }

    submit.addEventListener('click', runCalc);
    input.addEventListener('keydown', function (ev) {
      if (ev.key === 'Enter') {
        ev.preventDefault();
        runCalc();
      }
    });
  }

  function ringTapeOrderInitForm(scope) {
    var root = scope && scope.querySelector ? scope : document;
    var form = root.querySelector ? root.querySelector('#ring-tape-form') : document.getElementById('ring-tape-form');
    if (!form || form.dataset.ringTapeMerge === '1') {
      return;
    }
    form.dataset.ringTapeMerge = '1';

    var section = document.getElementById('bestill');
    var addressEl = document.getElementById('RingTapeAddress');
    var cityEl = document.getElementById('RingTapeCity');
    var postalEl = document.getElementById('RingTapePostal');
    var bodyEl = document.getElementById('RingTapeBody');

    var button = form.querySelector('[type="submit"]');
    if (!section || !addressEl || !cityEl || !postalEl || !bodyEl) {
      return;
    }

    // contact[body] for the contact post. False, with focus moved, when a field is empty.
    function ringTapeOrderMergeBody() {
      var address = addressEl.value.trim();
      var city = cityEl.value.trim();
      var postal = postalEl.value.trim();

      if (!address || !city || !postal) {
        if (!address) addressEl.focus();
        else if (!city) cityEl.focus();
        else postalEl.focus();
        return false;
      }

      var lblAddress = section.dataset.mergeAddress || 'Address';
      var lblCity = section.dataset.mergeCity || 'City';
      var lblPostal = section.dataset.mergePostal || 'Postal code';

      bodyEl.value = [
        lblAddress.concat(': ', address),
        lblCity.concat(': ', city),
        lblPostal.concat(': ', postal),
      ].join('\n');
      return true;
    }

    form.addEventListener('submit', function (e) {
      if (!ringTapeOrderMergeBody()) {
        e.preventDefault();
      }
    });

    if (!button) {
      return;
    }

    /*
      Luvora Backend turns the request into an order, sent from the button's
      click rather than the form's submit: Shopify's CAPTCHA takes over a
      contact form's submit and posts it natively, which left the page before
      the order request got out. Cancelling the click means no submit happens
      at all. Enter in a field clicks the button too.

      The contact form is the fallback. On any answer that is not ok, including
      a timeout, the button is clicked again with the flag set, so the form and
      its CAPTCHA post exactly as before and the request arrives by email.
    */
    button.addEventListener('click', function (e) {
      if (form.dataset.ringTapeNative === '1') {
        return;
      }
      // An invalid form goes on to the browser's own messages, which stop the submit.
      if (!form.checkValidity()) {
        return;
      }
      e.preventDefault();
      if (button.getAttribute('aria-busy') === 'true' || !ringTapeOrderMergeBody()) {
        return;
      }
      button.setAttribute('aria-busy', 'true');
      var startedAt = Date.now();

      var data = new FormData();
      data.append('firstName', ringTapeOrderValue('RingTapeFirstName'));
      data.append('lastName', ringTapeOrderValue('RingTapeLastName'));
      data.append('email', ringTapeOrderValue('RingTapeEmail'));
      data.append('phone', ringTapeOrderValue('RingTapePhone'));
      data.append('address', addressEl.value.trim());
      data.append('zip', postalEl.value.trim());
      data.append('city', cityEl.value.trim());

      var controller = window.AbortController ? new AbortController() : null;
      var timer = controller
        ? setTimeout(function () {
            controller.abort();
          }, 10000)
        : null;

      fetch('/apps/luvora-backend/ringmaler/submit', {
        method: 'POST',
        body: data,
        headers: { Accept: 'application/json' },
        signal: controller ? controller.signal : undefined,
      })
        .then(function (response) {
          return response.ok ? response.json() : null;
        })
        .catch(function () {
          return null;
        })
        .then(function (result) {
          clearTimeout(timer);
          // The spinner keeps turning through the fallback's page load.
          if (!result || !result.ok) {
            form.dataset.ringTapeNative = '1';
            button.click();
            return;
          }
          // The spinner shows for at least 2 s; a quicker answer flashed past unread.
          setTimeout(function () {
            button.removeAttribute('aria-busy');
            var heading = ringTapeOrderShowSuccess(section);
            if (heading) {
              heading.focus({ preventScroll: true });
            }
          }, Math.max(0, 2000 - (Date.now() - startedAt)));
        });
    });
  }

  function ringTapeOrderValue(id) {
    var el = document.getElementById(id);
    return el ? el.value.trim() : '';
  }

  /*
    Crossfades from the form to the confirmation. The form stays in the grid,
    inert, so the card keeps its height and the request cannot be sent twice.
    Returns the heading, for focus.
  */
  function ringTapeOrderShowSuccess(root) {
    var status = root && root.querySelector('[data-ring-tape-success]');
    var layer = root && root.querySelector('[data-ring-tape-form-layer]');
    if (!status || !layer) {
      return null;
    }
    layer.inert = true;
    status.classList.add('is-visible');
    return status.querySelector('[data-ring-tape-success-heading]');
  }

  function ringTapeOrderCleanUrl() {
    if (!window.history || !window.history.replaceState) {
      return;
    }
    if ((window.location.search || '').indexOf('contact_posted=true') === -1) {
      return;
    }
    window.history.replaceState(null, document.title, window.location.pathname);
  }

  function ringTapeOrderScrollToSuccess() {
    var section = document.getElementById('bestill');
    var form = document.getElementById('ring-tape-form');
    if (!section) {
      return;
    }
    var search = window.location.search || '';
    var posted = search.indexOf('contact_posted=true') !== -1;
    var status = section.querySelector('[data-ring-tape-success]');
    if (!posted && !(status && status.classList.contains('is-visible'))) {
      return;
    }
    ringTapeOrderShowSuccess(section);
    var reducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    section.scrollIntoView({ behavior: reducedMotion ? 'auto' : 'smooth', block: 'start' });
    ringTapeOrderCleanUrl();
  }

  // Keeps --ring-guide-header equal to the sticky header's height, for the jump targets' scroll-margin.
  function ringSizeGuideTrackHeader() {
    var header = document.getElementById('luvora-header');
    if (!header) {
      return;
    }
    function apply() {
      var height = header.getBoundingClientRect().height + 'px';
      document.querySelectorAll('.ring-size-guide').forEach(function (root) {
        root.style.setProperty('--ring-guide-header', height);
      });
    }
    apply();
    if (window.ResizeObserver) {
      new ResizeObserver(apply).observe(header);
    } else {
      window.addEventListener('resize', apply);
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    ringSizeGuideTrackHeader();
    document.querySelectorAll('[data-ring-size-calculator]').forEach(ringSizeGuideInitCalculator);
    ringTapeOrderInitForm(document);
    ringTapeOrderScrollToSuccess();
  });

  document.addEventListener('shopify:section:load', function (ev) {
    var found = ev.target && ev.target.querySelectorAll && ev.target.querySelectorAll('[data-ring-size-calculator]');
    if (found && found.length) {
      found.forEach(function (node) {
        node.removeAttribute('data-ring-calc-ready');
        ringSizeGuideInitCalculator(node);
      });
    }
    if (ev.target) {
      ringTapeOrderInitForm(ev.target);
      ringTapeOrderScrollToSuccess();
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["spesialdesign"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const form = document.getElementById('SpesialdesignForm');
    const root = document.getElementById('SpesialdesignFormRoot');
    if (!form || !root || form.dataset.sdFormMerge === '1') return;
    form.dataset.sdFormMerge = '1';

    const nameEl = document.getElementById('SpesialdesignName');
    const emailEl = document.getElementById('SpesialdesignEmail');
    const phoneEl = document.getElementById('SpesialdesignPhone');
    const jewelryEl = document.getElementById('SpesialdesignJewelryType');
    const materialEl = document.getElementById('SpesialdesignMaterial');
    const uploadUrlsEl = document.getElementById('SpesialdesignUploadUrls');
    const descriptionEl = document.getElementById('SpesialdesignDescription');
    const bodyEl = document.getElementById('SpesialdesignBody');

    const getUploadedUrls = () => {
      if (!uploadUrlsEl || !uploadUrlsEl.value) return [];
      return uploadUrlsEl.value.split('\n').map((line) => line.trim()).filter(Boolean);
    };

    const selectedLabel = (selectEl) => {
      if (!selectEl || selectEl.selectedIndex < 0) return '';
      return selectEl.options[selectEl.selectedIndex].text.trim();
    };

    form.addEventListener('submit', function (e) {
      if (!bodyEl || !nameEl || !emailEl || !jewelryEl || !materialEl || !descriptionEl) return;

      const name = nameEl.value.trim();
      const email = emailEl.value.trim();
      const phone = phoneEl ? phoneEl.value.trim() : '';
      const description = descriptionEl.value.trim();
      const jewelry = selectedLabel(jewelryEl);
      const material = selectedLabel(materialEl);

      if (!name || !email || !jewelry || !material || !description) {
        e.preventDefault();
        if (!name) nameEl.focus();
        else if (!email) emailEl.focus();
        else if (!jewelry) jewelryEl.focus();
        else if (!material) materialEl.focus();
        else descriptionEl.focus();
        return;
      }

      const uploadedUrls = getUploadedUrls();

      const lblJewelry = root.dataset.mergeJewelry || 'Jewelry type';
      const lblMaterial = root.dataset.mergeMaterial || 'Material';
      const lblImages = root.dataset.mergeImages || 'Images';
      const lblDescription = root.dataset.mergeDescription || 'Description';
      const lblPhone = root.dataset.mergePhone || 'Phone';

      const lines = [];
      if (phone) lines.push(''.concat(lblPhone, ': ', phone));
      lines.push(''.concat(lblJewelry, ': ', jewelry));
      lines.push(''.concat(lblMaterial, ': ', material));

      if (uploadedUrls.length) {
        lines.push(''.concat(lblImages, ':'));
        uploadedUrls.forEach((url, index) => {
          lines.push(''.concat(index + 1, '. ', url));
        });
      } else {
        lines.push(''.concat(lblImages, ': (none)'));
      }

      lines.push(''.concat(lblDescription, ':'), description);

      bodyEl.value = lines.join('\n');

      /*
       * Archive the enquiry in the app so the photos stay findable after the
       * email is buried. Fire and forget on purpose: Shopify's contact form is
       * what actually delivers the enquiry, so this must never delay it or
       * fail with it. sendBeacon survives the navigation the submit causes.
       */
      const idsEl = document.querySelector('[data-spesialdesign-upload-ids]');
      const record = new FormData();
      record.set('name', name);
      record.set('email', email);
      record.set('phone', phone);
      record.set('jewelryType', jewelry);
      record.set('material', material);
      record.set('description', description);
      const ids = idsEl && idsEl.value ? idsEl.value.split(',') : [];
      ids.forEach((id) => {
        if (id) record.append('fileIds', id);
      });
      try {
        navigator.sendBeacon('/apps/luvora-backend/spesialdesign/submit', record);
      } catch (beaconError) {
        /* The enquiry still reaches the inbox without us. */
      }
    });
  })();

  (function () {
    const SECTION_WRAPPER = '.spesialdesign-faq__inner';
    const DETAILS_SELECTOR = 'details.spesialdesign-faq__item';
    const CLIP_CLASS = 'spesialdesign-faq__answer-clip';
    const ANSWER_CLASS = 'spesialdesign-faq__answer';

    function prefersReducedMotion() {
      return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    }

    function bindDetails(details) {
      if (details.dataset.sdFaqMotionBound === '1') return;
      if (prefersReducedMotion()) return;

      const summary = details.querySelector(':scope > summary');
      const clip = details.querySelector(':scope > .'.concat(CLIP_CLASS));
      const answer = clip && clip.querySelector('.'.concat(ANSWER_CLASS));
      if (!summary || !clip || !answer) return;

      details.dataset.sdFaqMotionBound = '1';

      summary.addEventListener('click', function (e) {
        e.preventDefault();

        if (details.open) {
          clip.style.maxHeight = ''.concat(clip.scrollHeight, 'px');
          clip.getBoundingClientRect();
          clip.style.maxHeight = '0px';

          function onEnd(ev) {
            if (ev.target !== clip || ev.propertyName !== 'max-height') return;
            clip.removeEventListener('transitionend', onEnd);
            details.open = false;
            clip.style.maxHeight = '';
          }

          clip.addEventListener('transitionend', onEnd);
        } else {
          details.open = true;
          clip.style.maxHeight = '0px';
          var targetH = answer.scrollHeight;
          requestAnimationFrame(function () {
            requestAnimationFrame(function () {
              clip.style.maxHeight = ''.concat(targetH, 'px');
            });
          });

          function onOpenEnd(ev) {
            if (ev.target !== clip || ev.propertyName !== 'max-height') return;
            clip.removeEventListener('transitionend', onOpenEnd);
            if (details.open) clip.style.maxHeight = 'none';
          }

          clip.addEventListener('transitionend', onOpenEnd);
        }
      });
    }

    function initFaqMotion(root) {
      var scope = root || document;
      scope.querySelectorAll(SECTION_WRAPPER + ' ' + DETAILS_SELECTOR).forEach(bindDetails);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        initFaqMotion();
      });
    } else {
      initFaqMotion();
    }

    document.addEventListener('shopify:section:load', function (event) {
      if (event.target && event.target.querySelector && event.target.querySelector(SECTION_WRAPPER)) {
        initFaqMotion(event.target);
      }
    });
  })();

  (function () {
    const SCOOP_MQ = window.matchMedia('(min-width: 1024px)');

    const positionStepConnectors = function (root) {
      const scope = root || document;
      scope.querySelectorAll('.spesialdesign-steps__stack').forEach(function (stack) {
        if (!SCOOP_MQ.matches) {
          stack.style.removeProperty('--spesialdesign-connector-top');
          stack.style.removeProperty('--spesialdesign-connector-height');
          return;
        }

        const items = stack.querySelectorAll('.spesialdesign-steps__list > li');
        if (items.length < 2) return;

        const stackRect = stack.getBoundingClientRect();
        const firstRect = items[0].getBoundingClientRect();
        const lastRect = items[items.length - 1].getBoundingClientRect();
        const top = firstRect.top + firstRect.height / 2 - stackRect.top;
        const height =
          lastRect.top + lastRect.height / 2 - (firstRect.top + firstRect.height / 2);

        stack.style.setProperty('--spesialdesign-connector-top', top + 'px');
        stack.style.setProperty(
          '--spesialdesign-connector-height',
          Math.max(0, height) + 'px'
        );
      });
    };

    let resizeRaf = 0;
    const schedulePosition = function (root) {
      cancelAnimationFrame(resizeRaf);
      resizeRaf = requestAnimationFrame(function () {
        positionStepConnectors(root);
      });
    };

    const bindStack = function (stack) {
      if (stack.dataset.sdConnectorBound === '1') return;
      stack.dataset.sdConnectorBound = '1';

      if (typeof ResizeObserver !== 'undefined') {
        const ro = new ResizeObserver(function () {
          schedulePosition();
        });
        ro.observe(stack);
        stack.querySelectorAll('.spesialdesign-steps__list > li').forEach(function (li) {
          ro.observe(li);
        });
      }
    };

    const initConnectors = function (root) {
      const scope = root || document;
      scope.querySelectorAll('.spesialdesign-steps__stack').forEach(bindStack);
      schedulePosition(scope);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        initConnectors();
      });
    } else {
      initConnectors();
    }

    window.addEventListener(
      'resize',
      function () {
        schedulePosition();
      },
      { passive: true }
    );

    if (SCOOP_MQ.addEventListener) {
      SCOOP_MQ.addEventListener('change', function () {
        schedulePosition();
      });
    } else if (SCOOP_MQ.addListener) {
      SCOOP_MQ.addListener(function () {
        schedulePosition();
      });
    }

    document.addEventListener('shopify:section:load', function (event) {
      if (event.target && event.target.querySelector('.spesialdesign-steps__stack')) {
        initConnectors(event.target);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["support-form-bytte"]) return;
  try {
    
  (function () {
    const form = document.getElementById('SupportBytteForm');
    const root = document.getElementById('SupportBytteFormRoot');
    if (!form || !root || form.dataset.supportBytteMerge === '1') return;
    form.dataset.supportBytteMerge = '1';

    const orderEl = document.getElementById('BytteOrderNumber');
    const currentEl = document.getElementById('BytteCurrent');
    const requestedEl = document.getElementById('BytteRequested');
    const notesEl = document.getElementById('BytteNotes');
    const bodyEl = document.getElementById('SupportBytteBody');

    form.addEventListener('submit', function (e) {
      if (!bodyEl || !orderEl || !requestedEl) return;
      const order = orderEl.value.trim();
      const current = currentEl ? currentEl.value.trim() : '';
      const requested = requestedEl.value.trim();
      if (!order || !requested) {
        e.preventDefault();
        if (!order) orderEl.focus();
        else requestedEl.focus();
        return;
      }
      const lblOrder = root.dataset.mergeOrder || 'Order number';
      const lblCurrent = root.dataset.mergeCurrent || 'Current item';
      const lblRequested = root.dataset.mergeRequested || 'Requested exchange';
      const lblNotes = root.dataset.mergeNotes || 'Notes';
      const parts = [];
      parts.push(lblOrder.concat(': ', order));
      if (current) parts.push(lblCurrent.concat(': ', current));
      parts.push(lblRequested.concat(': ', requested));
      const notes = notesEl ? notesEl.value.trim() : '';
      if (notes) parts.push(lblNotes.concat(': ', notes));
      bodyEl.value = parts.join('\n\n');
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["support-form-reklamasjon"]) return;
  try {
    
  (function () {
    const form = document.getElementById('SupportReklamasjonForm');
    const root = document.getElementById('SupportReklamasjonFormRoot');
    if (!form || !root || form.dataset.supportReklMerge === '1') return;
    form.dataset.supportReklMerge = '1';

    const orderEl = document.getElementById('ReklOrderNumber');
    const productEl = document.getElementById('ReklProduct');
    const issueEl = document.getElementById('ReklIssue');
    const bodyEl = document.getElementById('SupportReklamasjonBody');

    form.addEventListener('submit', function (e) {
      if (!bodyEl || !orderEl || !issueEl) return;
      const order = orderEl.value.trim();
      const product = productEl ? productEl.value.trim() : '';
      const issue = issueEl.value.trim();
      if (!order || !issue) {
        e.preventDefault();
        if (!order) orderEl.focus();
        else issueEl.focus();
        return;
      }
      const lblOrder = root.dataset.mergeOrder || 'Order number';
      const lblProduct = root.dataset.mergeProduct || 'Product';
      const lblIssue = root.dataset.mergeIssue || 'Issue';
      const parts = [];
      parts.push(lblOrder.concat(': ', order));
      if (product) parts.push(lblProduct.concat(': ', product));
      parts.push(lblIssue.concat(': ', issue));
      bodyEl.value = parts.join('\n\n');
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["support-form-retur"]) return;
  try {
    
  (function () {
    const form = document.getElementById('SupportReturForm');
    const root = document.getElementById('SupportReturFormRoot');
    if (!form || !root || form.dataset.supportReturMerge === '1') return;
    form.dataset.supportReturMerge = '1';

    const orderEl = document.getElementById('ReturOrderNumber');
    const itemsEl = document.getElementById('ReturItems');
    const reasonEl = document.getElementById('ReturReason');
    const detailsEl = document.getElementById('ReturDetails');
    const bodyEl = document.getElementById('SupportReturBody');

    form.addEventListener('submit', function (e) {
      if (!bodyEl || !orderEl) return;
      const order = orderEl.value.trim();
      const items = itemsEl ? itemsEl.value.trim() : '';
      if (!order) {
        e.preventDefault();
        orderEl.focus();
        return;
      }
      const lblOrder = root.dataset.mergeOrder || 'Order number';
      const lblItems = root.dataset.mergeItems || 'Items';
      const lblReason = root.dataset.mergeReason || 'Reason';
      const lblDetails = root.dataset.mergeDetails || 'Details';
      const parts = [];
      parts.push(lblOrder.concat(': ', order));
      if (items) parts.push(lblItems.concat(': ', items));
      if (reasonEl && reasonEl.selectedIndex > 0) {
        const reasonText = reasonEl.options[reasonEl.selectedIndex].textContent.trim();
        if (reasonText) parts.push(lblReason.concat(': ', reasonText));
      }
      const details = detailsEl ? detailsEl.value.trim() : '';
      if (details) parts.push(lblDetails.concat(': ', details));
      bodyEl.value = parts.join('\n\n');
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
